import React, { useState, useEffect, useRef } from "react";
import { CSVLink } from "react-csv";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import {
  SlInput,
  SlButton,
  SlDrawer,
  SlTooltip,
  SlIcon,
  SlOption, SlSelect, SlTab, SlTabGroup, SlTabPanel
} from "@shoelace-style/shoelace/dist/react";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { DatetoTimestamp, formatDate, formatDateWithTimeYear } from "../../utils/dateFormat";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import { copyToClipboard } from "../../utils/copyToClipboard";
import { roles,getFirstKeyByValue } from "../../utils/constants";
import Modal from 'react-bootstrap/Modal';
import { orderPaymentTypes, TDS_PROOF_TYPES } from "../../utils/constants";
import { debounce } from "../../utils/Debounce";
import "../creatives/CreativeList.scss";

function CashfreePaymentLinkCreation() {
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [paymentArray, setPaymentArray] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [salesList, setSalesList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [initialRender, setInitialRender] = useState(true);
  const [searchString, setSearchString] = useState("");
  const [addDirectLink, setAddDirectLink] = useState("");
  const [downloadData, setDownloadData] = useState([])
  const [downloadLoader, setDownloadLoader] = useState(false)
  const csvLinkRef = useRef(); // Create a ref for CSVLink
  const navigate = useNavigate();
  const [selectedSalesPerson,setSelectedSalesPerson] = useState(null);
  const [selectedLinkStatus, setSelectedLinkStatus] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [showMultiOrderPayments, setShowMultiOrderPayments] = useState(false);
  const [multiOrderPayments, setMultiOrderPayments] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const LINK_STATUS_OPTIONS = [
    { value: "ACTIVE", label: "Active" },
    { value: "PAID", label: "Paid" },
    { value: "REJECTED", label: "Rejected" },
    { value: "EXPIRED", label: "Expired" },
  ];
  const [actionModal, setActionModal] = useState({
    isOpen: false,
    data: null,
    action: null,
    isEdit: false // Add this flag
  });
  const getInitialTab = (userRole) => {
    const tabMapping = {
      [roles.financer]: 'cheque',
      [roles.ops]: 'cashfree',
    };
    return tabMapping[userRole] || 'cashfree'; 
  };
  const [attachmentLightbox, setAttachmentLightbox] = useState(null);
  const [proofIndex, setProofIndex] = useState(0);
  const [rejectionReason, setRejectionReason] = useState("");
  const [tdsAmount, setTdsAmount] = useState("");
  const [tdsConfirmOpen, setTdsConfirmOpen] = useState(false);
  const [tdsReceiveModal, setTdsReceiveModal] = useState({ isOpen: false, data: null });
  const [tdsProofFile, setTdsProofFile] = useState(null);
  const [tdsReceiveLoading, setTdsReceiveLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(getInitialTab(localStorage.getItem('role')));
  const [orderSearchTerm, setOrderSearchTerm] = useState('');
  const [ordersList, setOrdersList] = useState([]);
  const [orderInvoicesCheque, setOrderInvoicesCheque] = useState([]);
  const [orderInvoicesCash, setOrderInvoicesCash] = useState([]);
  const [orderInvoicesIMPS, setOrderInvoicesIMPS] = useState([]);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [selectedOrderCheque, setSelectedOrderCheque] = useState(null);
  const [selectedOrderCash, setSelectedOrderCash] = useState(null);
  const [selectedOrderIMPS, setSelectedOrderIMPS] = useState(null);
  const tabGroupRef = useRef(null);
  const [multiOrderPaymentOptions, setMultiOrderPaymentOptions] = useState([]); // [{value: mopd_id, label: transaction_id, balance_amount: available_amount}]

  const getMaxAmountByMopdId = (mopdId) => {
    if (!mopdId) {
      return undefined;
    }
    const matchedOption = multiOrderPaymentOptions.find(option => option.value === mopdId);
    return matchedOption?.balance_amount;
  };
  
  const chequeFormik = useFormik({
    initialValues: {
      sales_person_id: 0,
      amount: '',
      order_id: '',
      transaction_id: '',
      payment_type: 'cheque',
      multi_order_payment: false,
      mopd_id: 0,
      transaction_type: 'regular',
      tds: '',
      invoice_no: '',
      payment_date: '',
    },
    validationSchema: Yup.object({
      sales_person_id: Yup.number().min(1, 'Please select a sales person').required('Sales person is required'),
      amount: Yup.number()
        .positive('Amount must be positive')
        .required('Amount is required')
        .test('max-by-mopd', 'Amount must be less than or equal to the maximum amount', function (value) {
          const { mopd_id } = this.parent || {};
          const maxAmount = getMaxAmountByMopdId(mopd_id);

          if (!mopd_id || value === undefined || value === null || value === '' || maxAmount === undefined || maxAmount === null) {
            return true;
          }
          return Number(value) <= Number(maxAmount);
        }),
      order_id:
      Yup.string().when('transaction_type', {
        is: (transactionType) => transactionType === 'regular' || transactionType === 'payment_of_multi_order_payment',
        then: Yup.string().required('Order ID is required'),
        otherwise: Yup.string().optional(),
      }),
      transaction_id: Yup.string().when('mopd_id', {
        is: (mopdId) => Boolean(mopdId),
        then: Yup.string().optional(),
        otherwise: Yup.string()
          .required('Transaction ID is required')
          .max(6, 'Transaction ID must be at most 6 characters')
          .matches(/^[0-9]+$/, 'Transaction ID must contain only numbers'),
      }),
      multi_order_payment: Yup.boolean().default(false),
      mopd_id: Yup.number().when('transaction_type', {
        is: 'payment_of_multi_order_payment',
        then: Yup.number().min(1, 'Please select payment of multi order payment').required('Please select payment of multi order payment'),
        otherwise: Yup.number().optional(),
      }),
      transaction_type: Yup.string()
        .oneOf(['regular', 'multi_order_payment', 'payment_of_multi_order_payment'])
        .required('Transaction type is required'),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        await addChequeOrCashPayment(values);
        resetForm();
        setShowForm(false);
      } catch (error) {
        console.error("Error in form submission:", error);
      } finally {
        setSubmitting(false);
      }
    }
  });
  
  const cashFormik = useFormik({
    initialValues: {
      sales_person_id: 0,
      amount: '',
      order_id: '',
      transaction_id: '',
      payment_type: 'cash',
      pan_no:'',
      multi_order_payment: false,
      mopd_id: 0,
      transaction_type: 'regular',
      tds: '',
      invoice_no: '',
      payment_date: '',
    },
    validationSchema: Yup.object({
      sales_person_id: Yup.number().min(1, 'Please select a sales person').required('Sales person is required'),
      amount: Yup.number()
        .positive('Amount must be positive')
        .required('Amount is required')
        .test('max-by-mopd', 'Amount must be less than or equal to the maximum amount', function (value) {
          const { mopd_id } = this.parent || {};
          const maxAmount = getMaxAmountByMopdId(mopd_id);

          if (!mopd_id || value === undefined || value === null || value === '' || maxAmount === undefined || maxAmount === null) {
            return true;
          }
          return Number(value) <= Number(maxAmount);
        }),
      order_id:
      Yup.string().when('transaction_type', {
        is: (transactionType) => transactionType === 'regular' || transactionType === 'payment_of_multi_order_payment',
        then: Yup.string().required('Order ID is required'),
        otherwise: Yup.string().optional(),
      }),
      transaction_id: Yup.string().when('mopd_id', {
        is: (mopdId) => Boolean(mopdId),
        then: Yup.string().optional(),
        otherwise: Yup.string().required('Transaction ID is required'),
      }),
      pan_no: Yup.string().when('transaction_type', {
        is: 'payment_of_multi_order_payment',
        then: Yup.string().optional(),
        otherwise: Yup.string()
          .required('PAN number is required')
          .length(10, 'PAN number must be exactly 10 characters')
          .matches(/^[a-zA-Z0-9]+$/, 'PAN number must contain only alphabets and numbers'),
      }),
      multi_order_payment: Yup.boolean().default(false),
      mopd_id: Yup.number().when('transaction_type', {
        is: 'payment_of_multi_order_payment',
        then: Yup.number().min(1, 'Please select payment of multi order payment').required('Please select payment of multi order payment'),
        otherwise: Yup.number().optional(),
      }),
      transaction_type: Yup.string()
        .oneOf(['regular', 'multi_order_payment', 'payment_of_multi_order_payment'])
        .required('Transaction type is required'),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        await addChequeOrCashPayment(values);
        resetForm();
        setShowForm(false);
      } catch (error) {
        console.error("Error in form submission:", error);
      } finally {
        setSubmitting(false);
      }
    }
  });

  const IMPS_NEFT_RTGSFormik = useFormik({
    initialValues: {
      sales_person_id: 0,
      amount: '',
      order_id: '',
      transaction_id: '',
      payment_type: 'IMPS/NEFT/RTGS',
      multi_order_payment: false,
      mopd_id: 0,
      transaction_type: 'regular',
      tds: '',
      invoice_no: '',
      payment_date: '',
    },
    validationSchema: Yup.object({
      sales_person_id: Yup.number().min(1, 'Please select a sales person').required('Sales person is required'),
      amount: Yup.number()
      .positive('Amount must be positive')
      .required('Amount is required')
      .test('max-by-mopd', 'Amount must be less than or equal to the maximum amount', function (value) {
        const { mopd_id } = this.parent || {};
        const maxAmount = getMaxAmountByMopdId(mopd_id);

        if (!mopd_id || value === undefined || value === null || value === '' || maxAmount === undefined || maxAmount === null) {
          return true;
        }
        return Number(value) <= Number(maxAmount);
      }),
      order_id:
      Yup.string().when('transaction_type', {
        is: (transactionType) => transactionType === 'regular' || transactionType === 'payment_of_multi_order_payment',
        then: Yup.string().required('Order ID is required'),
        otherwise: Yup.string().optional(),
      }),
      transaction_id: Yup.string().when('mopd_id', {
        is: (mopdId) => Boolean(mopdId),
        then: Yup.string().optional(),
        otherwise: Yup.string()
          .required('Transaction ID is required')
          .max(22, 'Transaction ID must be at most 22 characters')
          .matches(/^[a-zA-Z0-9]+$/, 'Transaction ID must contain only alphabets and numbers'),
      }),
      multi_order_payment: Yup.boolean().default(false),
      mopd_id: Yup.number().when('transaction_type', {
        is: 'payment_of_multi_order_payment',
        then: Yup.number().min(1, 'Please select payment of multi order payment').required('Please select payment of multi order payment'),
        otherwise: Yup.number().optional(),
      }),
      transaction_type: Yup.string()
        .oneOf(['regular', 'multi_order_payment', 'payment_of_multi_order_payment'])
        .required('Transaction type is required'),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        await addChequeOrCashPayment(values);
        resetForm();
        setShowForm(false);
      } catch (error) {
        console.error("Error in form submission:", error);
      } finally {
        setSubmitting(false);
      }
    }
  });
  useEffect(() => {
    if (showForm && tabGroupRef.current) {
      const defaultTab = getInitialTab(localStorage.getItem("role"));
      setActiveTab(defaultTab); 
      tabGroupRef.current.show(defaultTab);
    }
    else if(!showForm)
    {
      setSelectedOrderIMPS(null);
      setSelectedOrderCash(null);
      setSelectedOrderCheque(null);
      setOrderInvoicesCheque([]);
      setOrderInvoicesCash([]);
      setOrderInvoicesIMPS([]);
    }
  }, [showForm]);
  
  const fetchOrders = async (searchTerm,sales_person_id) => {
    if (!searchTerm || searchTerm.length < 2) {
      setOrdersList([]);
      return;
    }
    if(!sales_person_id)
     {
      Toast("error", "Select Sales Person id");
     return
     }
    
    try {
      setIsLoadingOrders(true);
      let res = await api({
        url: `/order/fetchOrdersbyIdOrName`,
        method: "POST",
        responseType: "json",
        data: {
          search:searchTerm,
          sales_person_id:sales_person_id
        }
      });
    if(res.status === 'SUCCESS')
    {
      setOrdersList(res.data)
    }
    } catch (error) {
      console.error('Error fetching orders:', error);
      setOrdersList([]);
    } finally {
      setIsLoadingOrders(false);
    }
  };

  const fetchOrderInvoices = async (order_id) => {
    if (!order_id) return [];
    try {
      let res = await api({
        url: "/order/get-order-invoice-by-order-id",
        method: "POST",
        responseType: "json",
        data: { order_id }
      });
      if(res.status === 'SUCCESS')
      {
        return res.data || [];
      }
      Toast("error", res.message || "Failed to fetch order invoices");
      return [];
    }
    catch (error) {
      console.error("Error fetching order invoices:", error);
      return [];
    }
  };

  const handleOrderSelect = async (selectedOption, setSelectedOrder, formikInstance, setInvoices) => {
    setSelectedOrder(selectedOption);
    const orderId = selectedOption?.value || "";
    formikInstance.setFieldValue("order_id", orderId);
    formikInstance.setFieldValue("invoice_no", "");
    if (orderId) {
      const invoices = await fetchOrderInvoices(orderId);
      setInvoices(invoices);
    } else {
      setInvoices([]);
    }
  };

  const clearPaymentMetaFields = (formikInstance, setInvoices) => {
    formikInstance.setFieldValue("tds", "");
    formikInstance.setFieldValue("invoice_no", "");
    formikInstance.setFieldValue("payment_date", "");
    setInvoices?.([]);
  };

  const renderFieldError = (error, touched) => (
    error && touched ? (
      <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "4px", fontWeight: "500" }}>
        {error}
      </div>
    ) : null
  );

  const renderPaymentMetaFields = (formikInstance, invoiceOptions, { invoiceDisabled = false, hideInvoice = false } = {}) => (
    <>
      <div style={{ marginBottom: "16px" }}>
        <SlInput
          label="TDS"
          type="number"
          placeholder="Enter TDS"
          value={formikInstance.values.tds}
          onSlInput={(e) => formikInstance.setFieldValue("tds", e.target.value)}
          onBlur={formikInstance.handleBlur}
          name="tds"
          style={{
            "--sl-input-border-radius": "6px",
            "--sl-input-border-width": "1px",
            "--sl-input-border-color":
              formikInstance.errors.tds && formikInstance.touched.tds
                ? "#dc3545"
                : "#ced4da",
          }}
        />
        {renderFieldError(formikInstance.errors.tds, formikInstance.touched.tds)}
      </div>

      {!hideInvoice && (
        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "8px" }}>Invoice No</label>
          <Select
            placeholder={invoiceDisabled ? "Select order to load invoices" : "Select invoice"}
            value={invoiceOptions.find((option) => option.value === formikInstance.values.invoice_no) || null}
            onChange={(selectedOption) => {
              formikInstance.setFieldValue("invoice_no", selectedOption?.value || "");
            }}
            options={invoiceOptions}
            isDisabled={invoiceDisabled || !formikInstance.values.order_id}
            onBlur={() => formikInstance.setFieldTouched("invoice_no", true)}
            isClearable
            styles={{
              control: (provided) => ({
                ...provided,
                borderRadius: "6px",
                borderWidth: "1px",
                borderColor:
                  formikInstance.errors.invoice_no && formikInstance.touched.invoice_no
                    ? "#dc3545"
                    : "#ced4da",
                boxShadow: "none",
                minHeight: "40px",
              }),
            }}
          />
          {renderFieldError(formikInstance.errors.invoice_no, formikInstance.touched.invoice_no)}
        </div>
      )}

      <div style={{ marginBottom: "16px" }}>
        <label style={{ display: "block", marginBottom: "8px" }}>Payment Date</label>
        <input
          type="date"
          className="form-control"
          value={formikInstance.values.payment_date}
          onChange={(e) => formikInstance.setFieldValue("payment_date", e.target.value)}
          onBlur={formikInstance.handleBlur}
          name="payment_date"
          style={{
            borderRadius: "6px",
            borderWidth: "1px",
            borderColor:
              formikInstance.errors.payment_date && formikInstance.touched.payment_date
                ? "#dc3545"
                : "#ced4da",
            minHeight: "40px",
          }}
        />
        {renderFieldError(formikInstance.errors.payment_date, formikInstance.touched.payment_date)}
      </div>
    </>
  );

  const addChequeOrCashPayment = async(values)=>{
    setLoading(true);
    try {
      delete values.transaction_type;
      const paymentData = {
        ...values,
        payment_type: values.payment_type === 'cheque' ? 2 : values.payment_type === 'cash' ? 3 : values.payment_type === 'IMPS/NEFT/RTGS' ? 4 : -1
      };
      let res = await api({
        url: "/order/addChequeOrCashPayment",
        method: "POST",
        responseType: "json",
        data: paymentData,
      });
      if (res.code === 200) {
        Toast("success", "Payment  added successfully");
        if(showMultiOrderPayments)
          getMultiOrderPayments();
        else
          getPaymentLink();
      } else {
        Toast(
          "error",
          res.data?.message || res.message || "Failed to add payment link"
        );
      }
    } catch (error) {
      console.error("Error @ addPaymentLinks", error);
      Toast("error", "Something went wrong!");
    } finally {
      setLoading(false);
    }
  }

  const handleOrderSearch = (inputValue,sales_person_id) => {
    if(inputValue.trim() === '')
      return;
    setOrderSearchTerm(inputValue);
    fetchOrders(inputValue,sales_person_id);
  };


  let csvHeaders = [
    { label: "Order Id", key: "order_id" },
    { label: "Order Start Date",key:"o_start_date"},
    { label: "Sales Person Name", key: "name" },
    { label: "Payment Type",key:"payment_type"},
    { label: "Link Id / Transaction Id", key: "link_id" },
    { label: "Cashfree Link Id", key: "cf_link_id" },
    { label: "Status", key: "link_status" },
    { label: "Amount", key: "link_amount" },
    { label: "Purpose", key: "link_purpose" },
    { label: "Link URL", key: "link_url" },
    { label: "PAN no", key: "pan_no" },
    { label: "TDS", key: "tds" },
    { label: "Payment Date", key: "payment_date" },
    { label: "Invoice No", key: "invoice_no" },
    { label: "Created By", key: "created_by_name" },
    { label: "Role", key: "created_user_role"},
    { label: "Approved By", key: "approved_by_name" },
    { label: "Customer Name", key: "customer_name" },
    { label: "Customer Email", key: "customer_email" },
    { label: "Customer Phone", key: "customer_phone" },
    { label: "Created At", key: "created_on" }
  ]
  
  const handleActionClick = (item, action) => {
    setActionModal({
      isOpen: true,
      data: item,
      action: action
    });
    setRejectionReason("");
    setTdsAmount("");
    setTdsConfirmOpen(false);
    setProofIndex(0);
  };
  const handleEditClick = (item) => {
    // Determine the opposite action
    const action = item.link_status === "PAID" ? "REJECTED" : "APPROVED";
    setActionModal({
      isOpen: true,
      data: item,
      action: action,
      isEdit: true // Flag to indicate this is an edit operation
    });
    setRejectionReason("");
    setTdsAmount("");
    setTdsConfirmOpen(false);
    setProofIndex(0);
  };
  const handleCloseModal = () => {
    setActionModal({ isOpen: false, data: null, action: null });
    setRejectionReason("");
    setTdsAmount("");
    setTdsConfirmOpen(false);
    setProofIndex(0);
  };
  const validateRejectionReason = (reason) => {
    const trimmedReason = reason.trim();
    
    // Check if empty
    if (!trimmedReason) {
      return { isValid: false, message: "Please provide a rejection reason" };
    }
    
    // Check minimum length (at least 3 characters)
    if (trimmedReason.length < 3) {
      return { isValid: false, message: "Rejection reason should be at least 3 characters" };
    }
    
    // Check if it contains only alphabets, numbers, and spaces
    const validPattern = /^[a-zA-Z0-9\s]+$/;
    if (!validPattern.test(trimmedReason)) {
      return { isValid: false, message: "Rejection reason can only contain letters, numbers, and spaces" };
    }
    
    // Check if it contains at least some alphabetic characters (not just numbers/spaces)
    const hasLetters = /[a-zA-Z]/.test(trimmedReason);
    if (!hasLetters) {
      return { isValid: false, message: "Rejection reason must contain at least some alphabets" };
    }
    
    return { isValid: true, message: "" };
  };
  // A transaction "already has TDS" when it carries a valid, positive tds value.
  const hasExistingTds = (item) => {
    const raw = String(item?.tds ?? "").trim();
    return raw !== "" && !Number.isNaN(Number(raw)) && Number(raw) > 0;
  };
  // The TDS booked on a transaction is a settlement transaction of its own, so it never
  // carries TDS again and it skips the TDS prompt on approval.
  const isTdsTransaction = (item) => Number(item?.payment_type) === tdsTypeValue;
  // tds_settlement_status is the status of the TDS transaction booked against this row.
  // A rejected one leaves the TDS pending again, so only a live one counts as settled.
  const isTdsSettled = (item) =>
    Boolean(item?.tds_settlement_status) && item.tds_settlement_status !== "REJECTED";
  // TDS is only real money once the payment it was deducted from is approved, so finance
  // can mark it received on PAID transactions that still carry an unsettled TDS.
  const canMarkTdsReceived = (item) =>
    localStorage.getItem("role") === roles.financer &&
    hasExistingTds(item) &&
    item?.link_status === "PAID" &&
    !isTdsTransaction(item) &&
    !isTdsSettled(item);
  const tdsStatusLabel = (item) => {
    if (!hasExistingTds(item)) return "";
    const status = item?.tds_settlement_status;
    if (!status) return "Pending with government";
    if (status === "REJECTED") return "Received - rejected on approval";
    if (status === "PAID") return "Received - approved";
    return "Received - pending approval";
  };
  const handleTdsReceivedClick = (item) => {
    setTdsReceiveModal({ isOpen: true, data: item });
    setTdsProofFile(null);
  };
  const closeTdsReceivedModal = () => {
    if (tdsReceiveLoading) return;
    setTdsReceiveModal({ isOpen: false, data: null });
    setTdsProofFile(null);
  };
  const handleTdsProofChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setTdsProofFile(null);
      return;
    }
    if (!TDS_PROOF_TYPES.includes(file.type)) {
      Toast("error", "Upload the proof as an image or a PDF");
      e.target.value = "";
      setTdsProofFile(null);
      return;
    }
    setTdsProofFile(file);
  };
  const uploadTdsProof = async (file) => {
    const formData = new FormData();
    formData.append("files", file);
    const res = await api({
      url: "/upload/file-upload",
      method: "POST",
      responseType: "json",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.code === 200 ? res.data?.data : null;
  };
  // Marking TDS as received books the TDS amount as a new ACTIVE transaction with the
  // proof attached; another financer approves or rejects it through the regular flow.
  const submitTdsReceived = async () => {
    const item = tdsReceiveModal.data;
    if (!item) return;
    if (!tdsProofFile) {
      Toast("error", "Upload the TDS proof to continue");
      return;
    }
    setTdsReceiveLoading(true);
    try {
      const link_url = await uploadTdsProof(tdsProofFile);
      if (!link_url) {
        Toast("error", "Failed to upload TDS proof");
        return;
      }
      let res = await api({
        url: "/order/markTdsReceived",
        method: "POST",
        responseType: "json",
        data: { opd_id: item.opd_id, link_url },
      });
      if (res.code === 200) {
        Toast("success", "TDS marked as received, the TDS transaction is pending approval");
        setTdsReceiveModal({ isOpen: false, data: null });
        setTdsProofFile(null);
        getPaymentLink();
      } else {
        Toast("error", res.data?.message || res.message || "Failed to mark TDS as received");
      }
    } catch (error) {
      console.error("Error @ submitTdsReceived", error);
      Toast("error", "Something went wrong!");
    } finally {
      setTdsReceiveLoading(false);
    }
  };
  // TDS is optional on approve; validate only when a value has been entered.
  const validateTdsAmount = (tds, amount) => {
    const trimmedTds = String(tds).trim();

    if (!trimmedTds) {
      return { isValid: true, message: "" };
    }

    if (!/^\d+(\.\d{1,2})?$/.test(trimmedTds)) {
      return { isValid: false, message: "TDS amount must be a valid positive number (up to 2 decimals)" };
    }

    const tdsValue = Number(trimmedTds);
    const paidAmount = Number(amount);
    if (!Number.isNaN(paidAmount) && tdsValue > paidAmount) {
      return { isValid: false, message: "TDS amount cannot be greater than the transaction amount" };
    }

    return { isValid: true, message: "" };
  };
  // Validation gate. Approve goes through an extra TDS confirmation step;
  // reject submits straight away.
  const handleSubmitAction = () => {
    const { action, data } = actionModal;

    if (action === "REJECTED") {
      const validation = validateRejectionReason(rejectionReason);
      if (!validation.isValid) {
        Toast("error", validation.message);
        return;
      }
      submitAction();
      return;
    }

    // Transaction already carries a TDS amount, or is itself a TDS settlement — approve
    // directly, no TDS prompt.
    if (hasExistingTds(data) || isTdsTransaction(data)) {
      submitAction();
      return;
    }

    const validation = validateTdsAmount(tdsAmount, data?.link_amount);
    if (!validation.isValid) {
      Toast("error", validation.message);
      return;
    }
    setTdsConfirmOpen(true);
  };
  const submitAction = async () => {
    const { action, data } = actionModal;
    const trimmedTds = String(tdsAmount).trim();

    try {
      const payload = {
        opd_id: data.opd_id,
        action: action,
        ...(action === "REJECTED" && { rej_reason: rejectionReason }),
        ...(action === "APPROVED" && trimmedTds !== "" && { tds: Number(trimmedTds) })
      };
      
      
      let res = await api({
        url: `/order/orderPaymentActions`,
        method: "POST",
        responseType: "json",
        data: payload
      });
      if(res?.code === 200) {
        setTdsConfirmOpen(false);
        setActionModal({ isOpen: false, data: null, action: null, isEdit: false });
        setRejectionReason("");
        setTdsAmount("");
        getPaymentLink();
      }
      else {
        setTdsConfirmOpen(false);
        Toast('error',res?.data?.message)
      }
    } catch (error) {
      setTdsConfirmOpen(false);
      console.error(`Error ${action}ing transaction:`, error);
    }
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
  const addPaymentLink = async (newPaymentDetails) => {
    setLoading(true);
    try {
      let res = await api({
        url: "/order/add-payment-link",
        method: "POST",
        responseType: "json",
        data: { ...newPaymentDetails },
      });
      if (res.code === 200) {
        Toast("success", "Payment link added successfully");
        getPaymentLink();
      } else {
        Toast(
          "error",
          res.data?.message || res.message || "Failed to add payment link"
        );
      }
    } catch (error) {
      console.error("Error @ addPaymentLinks", error);
      Toast("error", "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  const deleteOrderPaymentLink = async (opd_id) => {
    setFetchLoading(true);
    try {
      let res = await api({
        url: "/order/delete-payment-link",
        method: "POST",
        responseType: "json",
        data: { opd_id },
      });
      if (res.code === 200) {
        Toast("success", "Payment link deleted successfully");
        getPaymentLink();
      } else {
        Toast(
          "error",
          res.data?.message || res.message || "Failed to delete payment link"
        );
        setFetchLoading(false);
      }
    } catch (error) {
      console.error("Error @ deleteOrderPaymentLink", error);
      Toast("error", "Something went wrong!");
      setFetchLoading(false);
    }
  };
  // Validation schema
  const validationSchema = Yup.object({
    sales_person_id: Yup.number()
      .required("Sales person is required")
      .min(1, "Sales person is required"),
    link_amount: Yup.string().required("Amount is required"),
    link_purpose: Yup.string().required("Link purpose is required"),
    customer_phone: Yup.string().required("Customer phone is required").min(10, "Customer phone must be 10 digits").max(10, "Customer phone must be 10 digits"),
    customer_name: Yup.string(),
    customer_email: Yup.string().email("Invalid email format"),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      sales_person_id: 0,
      link_amount: "",
      link_purpose: "",
      customer_email: "",
      customer_name: "",
      customer_phone: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        await addPaymentLink(values);
        resetForm();
        setShowForm(false);
      } catch (error) {
        console.error("Error in form submission:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const getSalesList = async () => {
    try {
      let salesListResponse = await api({
        url: "/user/sales_persons/getSalesUsers",
        method: "POST",
        responseType: "json",
      });
      if (salesListResponse.code === 200) {
        setSalesList(salesListResponse.data || []);
      }
    } catch (error) {
      console.log("Error @ getSalesList", error);
    }
  };

  // const editOrderPaymentLink = async(link_id, opd_id)=>{
  //   try {
  //     let res = await api({
  //       url: "/order/edit-payment-link",
  //       method: "POST",
  //       responseType: "json",
  //       data: { link_id, opd_id }
  //     })
  //     if(res.code === 200){
  //       Toast("success", "Payment link edited successfully")
  //       getPaymentLink(order_id)
  //       setEditPaymentOpdId(null)
  //       setEditPaymentLinkId(null)
  //     }else{
  //       Toast("error", res.message)
  //       setEditPaymentOpdId(null)
  //       setEditPaymentLinkId(null)
  //     }
  //   } catch (error) {
  //     console.error("Error @ editOrderPaymentLink", error)
  //     Toast("error", "Something went wrong!")
  //   }
  // }
  const getPaymentLink = async () => {
    setFetchLoading(true);
    try {
      let res = await api({
        url: "/order/get-payment-links",
        method: "POST",
        responseType: "json",
        data: { currentPage, limit: config.PER_PAGE, searchString, sales_person_id: selectedSalesPerson?.value, link_status: selectedLinkStatus?.value || null, payment_type: selectedPaymentType?.value || null },
      });
      if (res.code === 200) {
        setPaymentArray(res.data?.paymentLinks || []);
        setTotalPages(Math.ceil(res.data?.totalCount / config.PER_PAGE) || 0);
      } else {
        Toast("error", res.message || "Failed to fetch payment links");
      }
      setInitialRender(false);
    } catch (error) {
      console.error("Error @ getPaymentLink", error);
      Toast("error", "Something went wrong!");
    } finally {
      setFetchLoading(false);
    }
  };

  const handleAddDirectLink = async () => {
    try {
      let res = await api({
        url: "/order/add-direct-link",
        method: "POST",
        responseType: "json",
        data: { link_id: addDirectLink },
      });
      if (res.code === 200) {
        Toast("success", "Direct link added successfully");
        getPaymentLink();
        setAddDirectLink("");
        setShowForm(false)
      } else {
        Toast("error", res.message || "Failed to add direct link");
      }
    } catch (error) {
      console.error("Error @ handleAddDirectLink", error);
    }
  }
  const download = async () => {
    try {
      setDownloadLoader(true)
      let res = await api({
        url: "/order/get-payment-links",
        method: "POST",
        responseType: "json",
        data: { searchString, sales_person_id: selectedSalesPerson?.value, link_status: selectedLinkStatus?.value || null, payment_type: selectedPaymentType?.value || null },
      });
      if (res.code === 200) {
        setDownloadData(res.data?.paymentLinks)
      } else {
        Toast("error", res.message || "Failed to fetch payment links");
      }
      setDownloadLoader(false)
    } catch (error) {
      console.error("Error @ download", error);
    }
  }

  const handleNavigateToOrder = (linkId) => {
    if (!linkId) return;
    navigate(`/home/order/add?link=${encodeURIComponent(linkId)}`);
  };


  useEffect(() => {
    if (downloadData.length) {
        csvLinkRef?.current?.link?.click();
        setDownloadData([]);
    }
}, [downloadData]);

  useEffect(() => {
    getPaymentLink();
    getSalesList();
  }, []);

  const getMultiOrderPayments = async () => {
    try {
      let res = await api({
        url: "/order/get-multi-order-payments",
        method: "POST",
        responseType: "json",
        data: { searchString, sales_person_id: selectedSalesPerson?.value, link_status: selectedLinkStatus?.value || null, payment_type: selectedPaymentType?.value || null, currentPage, limit: config.PER_PAGE },
      });
      if(res.code === 200){
        setMultiOrderPayments(res.data?.data || []);
        setTotalPages(Math.ceil(res.data?.totalCount / config.PER_PAGE) || 0);
      } else {
        Toast("error", res.message || "Failed to fetch multi order payments");
      }
    }
    catch (error) {
      console.error("Error @ getMultiOrderPayments", error);
    }
  }

  useEffect(() => {
    if(showMultiOrderPayments){
      getMultiOrderPayments();
    }
    else if (!initialRender) getPaymentLink();
  }, [showMultiOrderPayments, currentPage, searchString, selectedSalesPerson, selectedLinkStatus, selectedPaymentType]);

  const getMultiOrderPaymentOptions = async (payment_type) => {
    try {
      let res = await api({
        url: "/order/get-multi-order-payment-options",
        method: "POST",
        responseType: "json",
        data: { payment_type: payment_type === "cashfree" ? 1 : payment_type === "cheque" ? 2 : payment_type === "cash" ? 3 : payment_type === "IMPS/NEFT/RTGS" ? 4 : undefined }
      });
      if (res.code === 200) {
        setMultiOrderPaymentOptions(res.data || []);
      } else {
        Toast("error", res.message || "Failed to fetch multi order payment options");
      }
    }catch (error) {
      console.error("Error @ getMultiOrderPaymentOptions", error);
    }
  }

  useEffect(() => {
    if (activeTab !== "cashfree") {
      getMultiOrderPaymentOptions(activeTab);
    }
  }, [activeTab]);


  const handleMultiOrderPaymentActionClick = async (item, action) => {
    try {
      let res = await api({
        url: "/order/multi-order-payment-approve-reject",
        method: "POST",
        responseType: "json",
        data: { mopd_id: item.mopd_id, action }
      });
      if(res.code === 200){
        Toast("success", res.message || "Multi order payment action performed successfully");
        getMultiOrderPayments();
      } else {
        Toast("error", res?.data?.message || "Failed to perform multi order payment action");
      }
    } catch (error) {
      console.error("Error @ handleMultiOrderPaymentActionClick", error);
    }
  }


  const cashfreeTypeValue = orderPaymentTypes.find((i) => i.label === "Cashfree")?.value;
  const tdsTypeValue = orderPaymentTypes.find((i) => i.label === "TDS")?.value;
  const cfBtn = {
    approve: "inline-flex items-center rounded-md border border-green-200 bg-green-50 px-2.5 py-1 text-xs font-semibold text-green-700 transition-colors hover:bg-green-100",
    reject: "inline-flex items-center rounded-md border border-red-200 bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700 transition-colors hover:bg-red-100",
    edit: "inline-flex items-center rounded-md border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700 transition-colors hover:bg-amber-100",
    tds: "inline-flex items-center rounded-md border border-indigo-200 bg-indigo-50 px-2.5 py-1 text-xs font-semibold text-indigo-700 transition-colors hover:bg-indigo-100",
  };
  const cfSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  };
  const statusMeta = (s) => {
    const v = (s || "").toUpperCase();
    if (v === "PAID") return "bg-green-50 text-green-700";
    if (v === "ACTIVE") return "bg-blue-50 text-blue-700";
    if (v === "EXPIRED" || v === "REJECTED" || v === "FAILED" || v === "CANCELLED") return "bg-red-50 text-red-700";
    return "bg-slate-100 text-slate-500";
  };
  const cfField = (label, value, copyVal) => (
    <div className="flex items-start justify-between gap-3 py-[3px]">
      <span className="shrink-0 text-[11px] font-medium uppercase tracking-wide text-slate-400">{label}</span>
      <span className="flex min-w-0 items-center justify-end gap-1.5 text-right text-[13px] font-medium text-slate-700">
        <span className="break-all">{[undefined, null, ""].includes(value) ? "—" : value}</span>
        {copyVal ? (
          <button type="button" onClick={(e) => { e.stopPropagation(); copyToClipboard(copyVal); }} className="shrink-0 text-slate-400 hover:text-[#4952FA]" title="Copy"><SlIcon library="lucide" name="copy" /></button>
        ) : null}
      </span>
    </div>
  );
  const cfSection = (title, rows) => (
    <div className="min-w-0">
      <div className="mb-1.5 text-[11px] font-bold uppercase tracking-wider text-[#4952FA]">{title}</div>
      {rows}
    </div>
  );
  const tdsProofLink = (url) => (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="text-[#4952FA] underline"
    >
      View proof
    </a>
  );
  const cfAttachments = (list) => {
    const attachments = Array.isArray(list) ? list.filter((url) => typeof url === "string" && url) : [];
    if (!attachments.length) {
      return <span className="text-[13px] text-slate-400">No attachments</span>;
    }
    return (
      <div className="flex flex-wrap gap-2">
        {attachments.map((url, i) => (
          <a
            key={`${url}-${i}`}
            href={url}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="block h-14 w-14 shrink-0 overflow-hidden rounded-md border border-slate-200 bg-slate-50"
            title={`Attachment ${i + 1}`}
          >
            <img
              src={url}
              alt={`Attachment ${i + 1}`}
              className="h-full w-full object-cover"
              onError={(e) => { e.target.onerror = null; e.target.style.display = "none"; }}
            />
          </a>
        ))}
      </div>
    );
  };

  return (
    <div className="cf-txn-page flex flex-col h-[calc(100vh-72px)]">
      <CSVLink
        data={downloadData.map(
          (item) => {

            let obj = item;
            item.created_on = item.created_on ? formatDateWithTimeYear(item.created_on) : '-';
            item.o_start_date = item.o_start_date ? formatDateWithTimeYear(item.o_start_date) : '-'
            item.payment_date = item.payment_date ? formatDate(item.payment_date) : '-'
            item.payment_type = orderPaymentTypes.find(t=>t.value === Number(item.payment_type))?.label || "-"
            item.created_user_role = item?.created_user_role ? getFirstKeyByValue(roles,item.created_user_role)?.toUpperCase() : "-" 
            return obj;
          }
        )}
        headers={csvHeaders}
        filename={"Cashfree_links.csv"}
        ref={csvLinkRef}
      ></CSVLink>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        {/* Header */}
        <div className="flex flex-wrap items-start justify-between gap-3 px-5 pt-4 pb-3">
          <div>
            <h1 className="mb-0 text-xl font-semibold text-slate-800">Transactions</h1>
            <p className="mb-0 mt-0.5 text-[13px] text-slate-400">Expand any row to see the full transaction record</p>
          </div>
          {(localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.financer) ? (
            <SlButton variant="primary" onClick={() => setShowForm(true)}>
              <SlIcon library="lucide" name="plus" slot="prefix"></SlIcon>
              Add Payment Link
            </SlButton>
          ) : null}
        </div>

        {/* Filter bar */}
        <div className="flex flex-wrap items-center gap-2 border-y border-slate-100 bg-white px-5 py-3">
          <div className="inline-flex items-center rounded-lg bg-[#F1F2F4] p-1">
            <button type="button" onClick={() => { setCurrentPage(0); setSearchString(""); setSelectedSalesPerson(null); setSelectedLinkStatus(null); setSelectedPaymentType(null); setExpandedRow(null); setShowMultiOrderPayments(false); }} className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${!showMultiOrderPayments ? "bg-white text-[#4952FA] shadow-sm" : "text-gray-500 hover:text-gray-700"}`}>Regular Transactions</button>
            <button type="button" onClick={() => { setCurrentPage(0); setSearchString(""); setSelectedSalesPerson(null); setSelectedLinkStatus(null); setSelectedPaymentType(null); setExpandedRow(null); setShowMultiOrderPayments(true); }} className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${showMultiOrderPayments ? "bg-white text-[#4952FA] shadow-sm" : "text-gray-500 hover:text-gray-700"}`}>Multi Order Transactions</button>
          </div>
          <div className="min-w-[220px] flex-1">
            <SlInput className="w-full" type="text" placeholder="Search order id, link id, customer…" value={searchString} onSlInput={(e) => setSearchString(e.target.value)}>
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
          </div>
          <div className="w-44"><Select options={salesList} value={selectedSalesPerson} onChange={(e) => setSelectedSalesPerson(e)} isClearable={true} placeholder="Sales person" menuPortalTarget={document.body} styles={cfSelectStyles} /></div>
          <div className="w-44"><Select options={LINK_STATUS_OPTIONS} value={selectedLinkStatus} onChange={(e) => setSelectedLinkStatus(e)} isClearable={true} placeholder="Filter by status" menuPortalTarget={document.body} styles={cfSelectStyles} /></div>
          <div className="w-48"><Select options={orderPaymentTypes} value={selectedPaymentType} onChange={(e) => setSelectedPaymentType(e)} isClearable={true} placeholder="Payment type" menuPortalTarget={document.body} styles={cfSelectStyles} /></div>
          {downloadLoader ? (<TableLoader />) : (
            <sl-tooltip content="Download">
              <button type="button" onClick={() => download()} className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition-colors hover:border-[#4952FA] hover:text-[#4952FA]"><SlIcon library="lucide" name="download"></SlIcon></button>
            </sl-tooltip>
          )}
        </div>

        {/* Table */}
        <div className="min-h-0 flex-1 overflow-auto">
          {!showMultiOrderPayments ? (
            <>
            <table className="cf-txn-table mobHide">
              <thead>
                <tr>
                  <th style={{ width: "40px" }}></th>
                  <th style={{ width: "52px" }}>#</th>
                  <th>Order Id</th>
                  <th>Customer</th>
                  <th>Payment Type</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Created At</th>
                  {localStorage.getItem("role") === roles.financer ? <th>Actions</th> : null}
                </tr>
              </thead>
              {fetchLoading ? (
                <TableLoader colspan={localStorage.getItem("role") === roles.financer ? 9 : 8} />
              ) : paymentArray?.length > 0 ? (
                <tbody>
                  {paymentArray.map((item, index) => {
                    const isOpen = expandedRow === index;
                    const canAct = localStorage.getItem("role") === roles.financer;
                    const ptLabel = orderPaymentTypes.find((t) => t.value === Number(item?.payment_type))?.label || "-";
                    return (
                      <React.Fragment key={index}>
                        <tr className={`cf-summary ${isOpen ? "cf-open" : ""}`} onClick={() => setExpandedRow(isOpen ? null : index)}>
                          <td><SlIcon library="lucide" name={isOpen ? "chevron-down" : "chevron-right"} className="text-slate-400" /></td>
                          <td className="text-slate-400">{index + 1}</td>
                          <td className="font-semibold text-slate-800">
                            {item.order_id || (
                              <SlButton size="small" variant="default" onClick={(e) => { e.stopPropagation(); handleNavigateToOrder(item.link_id); }} disabled={!item.link_id}>Create Order</SlButton>
                            )}
                          </td>
                          <td>
                            <div className="font-medium text-slate-800">{item.customer_name || "—"}</div>
                            {item.customer_phone ? <div className="text-xs text-slate-400">{item.customer_phone}</div> : null}
                          </td>
                          <td>{ptLabel}</td>
                          <td className="font-semibold text-slate-800">{item.link_amount ? `₹${item.link_amount}` : "-"}</td>
                          <td><span className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${statusMeta(item.link_status)}`}>{item.link_status || "-"}</span></td>
                          <td className="whitespace-nowrap text-slate-500">{item?.created_on ? formatDateWithTimeYear(item.created_on) : "-"}</td>
                          {canAct ? (
                            <td onClick={(e) => e.stopPropagation()}>
                              <div className="flex flex-wrap gap-1.5">
                                {item.link_status === "ACTIVE" && item?.payment_type != cashfreeTypeValue ? (
                                  <>
                                    <button type="button" className={cfBtn.approve} onClick={() => handleActionClick(item, "APPROVED")}>Approve</button>
                                    <button type="button" className={cfBtn.reject} onClick={() => handleActionClick(item, "REJECTED")}>Reject</button>
                                  </>
                                ) : (item.link_status === "PAID" || item.link_status === "REJECTED") && item?.payment_type != cashfreeTypeValue ? (
                                  <button type="button" className={cfBtn.edit} onClick={() => handleEditClick(item)}>Edit</button>
                                ) : null}
                                {canMarkTdsReceived(item) ? (
                                  <button type="button" className={cfBtn.tds} onClick={() => handleTdsReceivedClick(item)}>Mark TDS Received</button>
                                ) : null}
                                {!canMarkTdsReceived(item) &&
                                (item?.payment_type == cashfreeTypeValue ||
                                  !["ACTIVE", "PAID", "REJECTED"].includes(item.link_status)) ? (
                                  <span className="text-slate-300">—</span>
                                ) : null}
                              </div>
                            </td>
                          ) : null}
                        </tr>
                        {isOpen ? (
                          <tr className="cf-detail">
                            <td colSpan={canAct ? 9 : 8}>
                              <div className="bg-[#fafbfe] px-5 py-4">
                                <div className="grid grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
                                  {cfSection("Transaction", (
                                    <>
                                      {cfField("Link / Txn Id", item.link_id, item.link_id)}
                                      {cfField("Cashfree Link Id", item.cf_link_id)}
                                      {cfField("Link URL", item.link_url, item.link_url)}
                                      {cfField("Purpose", item.link_purpose)}
                                      {isTdsTransaction(item) ? cfField("TDS Of Txn", item.tds_ref_link_id, item.tds_ref_link_id) : null}
                                      {isTdsTransaction(item) && item.tds_ref_amount ? cfField("Txn Amount", `₹${item.tds_ref_amount}`) : null}
                                    </>
                                  ))}
                                  {cfSection("Order", (
                                    <>
                                      {cfField("Order Id", item.order_id)}
                                      {cfField("Order Start Date", item.o_start_date ? formatDateWithTimeYear(item.o_start_date) : "")}
                                      {cfField("Payment Type", ptLabel)}
                                    </>
                                  ))}
                                  {cfSection("Payment", (
                                    <>
                                      {cfField("Amount", item.link_amount ? `₹${item.link_amount}` : "")}
                                      {cfField("TDS", item.tds)}
                                      {hasExistingTds(item) ? cfField("TDS Status", tdsStatusLabel(item)) : null}
                                      {item.tds_settlement_proof ? cfField("TDS Proof", tdsProofLink(item.tds_settlement_proof)) : null}
                                      {cfField("PAN No", item.pan_no)}
                                      {cfField("Invoice No", item.invoice_no)}
                                      {cfField("Payment Date", item.payment_date ? formatDate(item.payment_date) : "")}
                                    </>
                                  ))}
                                  {cfSection("People", (
                                    <>
                                      {cfField("Created By", item.created_by_name)}
                                      {cfField("Created User Role", getFirstKeyByValue(roles, item.created_user_role)?.toUpperCase())}
                                      {cfField("Approved By", item.approved_by_name)}
                                    </>
                                  ))}
                                  {cfSection("Customer", (
                                    <>
                                      {cfField("Name", item.customer_name)}
                                      {cfField("Email", item.customer_email)}
                                      {cfField("Phone", item.customer_phone)}
                                    </>
                                  ))}
                                  {cfSection("Attachments", cfAttachments(item.attachment))}
                                </div>
                                <div className="mt-4 flex flex-wrap items-center gap-3 border-t border-slate-200 pt-3">
                                  <div className="text-[11px] font-medium uppercase tracking-wide text-slate-400">Created At<span className="ml-2 text-[13px] font-medium normal-case text-slate-600">{item?.created_on ? formatDateWithTimeYear(item.created_on) : "—"}</span></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : null}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              ) : (
                <NoDataFound colspan={localStorage.getItem("role") === roles.financer ? 9 : 8} />
              )}
            </table>
            {/* Mobile cards */}
            <div className="flex flex-col gap-3 p-3 md:hidden">
              {fetchLoading ? (
                <div className="flex justify-center py-8"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
              ) : paymentArray?.length > 0 ? (
                paymentArray.map((item, index) => {
                  const isOpen = expandedRow === index;
                  const canAct = localStorage.getItem("role") === roles.financer;
                  const ptLabel = orderPaymentTypes.find((t) => t.value === Number(item?.payment_type))?.label || "-";
                  return (
                    <div key={index} className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
                      <div className="p-3">
                        <div className="flex items-start justify-between gap-2">
                          <div className="min-w-0">
                            <div className="truncate font-semibold text-slate-800">{item.customer_name || "—"}</div>
                            <div className="mt-0.5 text-xs text-slate-400">#{index + 1}{item.customer_phone ? ` · ${item.customer_phone}` : ""}</div>
                          </div>
                          <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${statusMeta(item.link_status)}`}>{item.link_status || "-"}</span>
                        </div>
                        <div className="mt-2.5 flex items-end justify-between gap-2">
                          <div className="min-w-0">
                            {item.order_id ? (
                              <div className="truncate font-mono text-[13px] text-slate-700">{item.order_id}</div>
                            ) : (
                              <SlButton size="small" variant="default" onClick={() => handleNavigateToOrder(item.link_id)} disabled={!item.link_id}>Create Order</SlButton>
                            )}
                            <div className="mt-0.5 text-xs text-slate-400">{ptLabel}{item?.created_on ? ` · ${formatDateWithTimeYear(item.created_on)}` : ""}</div>
                          </div>
                          <div className="shrink-0 whitespace-nowrap text-lg font-bold text-slate-800">{item.link_amount ? `₹${item.link_amount}` : "-"}</div>
                        </div>
                      </div>
                      <button type="button" onClick={() => setExpandedRow(isOpen ? null : index)} className="flex w-full items-center justify-center gap-1 border-t border-slate-100 py-2 text-sm font-semibold text-[#4952FA]">
                        {isOpen ? "Hide details" : "View all fields"}<SlIcon library="lucide" name={isOpen ? "chevron-up" : "chevron-down"} />
                      </button>
                      {isOpen ? (
                        <div className="border-t border-slate-100 bg-[#fafbfe] p-3">
                          <div className="grid grid-cols-1 gap-4">
                            {cfSection("Transaction", (
                              <>
                                {cfField("Link / Txn Id", item.link_id, item.link_id)}
                                {cfField("Cashfree Link Id", item.cf_link_id)}
                                {cfField("Link URL", item.link_url, item.link_url)}
                                {cfField("Purpose", item.link_purpose)}
                                {isTdsTransaction(item) ? cfField("TDS Of Txn", item.tds_ref_link_id, item.tds_ref_link_id) : null}
                                {isTdsTransaction(item) && item.tds_ref_amount ? cfField("Txn Amount", `₹${item.tds_ref_amount}`) : null}
                              </>
                            ))}
                            {cfSection("Order", (
                              <>
                                {cfField("Order Id", item.order_id)}
                                {cfField("Order Start Date", item.o_start_date ? formatDateWithTimeYear(item.o_start_date) : "")}
                                {cfField("Payment Type", ptLabel)}
                              </>
                            ))}
                            {cfSection("Payment", (
                              <>
                                {cfField("Amount", item.link_amount ? `₹${item.link_amount}` : "")}
                                {cfField("TDS", item.tds)}
                                {hasExistingTds(item) ? cfField("TDS Status", tdsStatusLabel(item)) : null}
                                {item.tds_settlement_proof ? cfField("TDS Proof", tdsProofLink(item.tds_settlement_proof)) : null}
                                {cfField("PAN No", item.pan_no)}
                                {cfField("Invoice No", item.invoice_no)}
                                {cfField("Payment Date", item.payment_date ? formatDate(item.payment_date) : "")}
                              </>
                            ))}
                            {cfSection("People", (
                              <>
                                {cfField("Created By", item.created_by_name)}
                                {cfField("Created User Role", getFirstKeyByValue(roles, item.created_user_role)?.toUpperCase())}
                                {cfField("Approved By", item.approved_by_name)}
                              </>
                            ))}
                            {cfSection("Customer", (
                              <>
                                {cfField("Name", item.customer_name)}
                                {cfField("Email", item.customer_email)}
                                {cfField("Phone", item.customer_phone)}
                              </>
                            ))}
                            {cfSection("Attachments", cfAttachments(item.attachment))}
                            {cfSection("Audit", cfField("Created At", item?.created_on ? formatDateWithTimeYear(item.created_on) : ""))}
                          </div>
                          {canAct ? (
                            <div className="mt-3 flex flex-wrap gap-1.5 border-t border-slate-200 pt-3">
                              {item.link_status === "ACTIVE" && item?.payment_type != cashfreeTypeValue ? (
                                <>
                                  <button type="button" className={cfBtn.approve} onClick={() => handleActionClick(item, "APPROVED")}>Approve</button>
                                  <button type="button" className={cfBtn.reject} onClick={() => handleActionClick(item, "REJECTED")}>Reject</button>
                                </>
                              ) : (item.link_status === "PAID" || item.link_status === "REJECTED") && item?.payment_type != cashfreeTypeValue ? (
                                <button type="button" className={cfBtn.edit} onClick={() => handleEditClick(item)}>Edit</button>
                              ) : null}
                              {canMarkTdsReceived(item) ? (
                                <button type="button" className={cfBtn.tds} onClick={() => handleTdsReceivedClick(item)}>Mark TDS Received</button>
                              ) : null}
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  );
                })
              ) : (
                <div className="py-10 text-center text-sm text-slate-400">No transactions found</div>
              )}
            </div>
            </>
          ) : (
            <>
            <table className="cf-txn-table mobHide">
              <thead>
                <tr>
                  <th>Payment Type</th>
                  <th>Transaction ID</th>
                  <th>Sales Person</th>
                  <th>Amount</th>
                  <th>Balance Amount</th>
                  <th>Status</th>
                  {localStorage.getItem("role") === roles.financer ? <th>Actions</th> : null}
                </tr>
              </thead>
              {multiOrderPayments?.length > 0 ? (
                <tbody>
                  {multiOrderPayments.map((item, index) => (
                    <tr key={index}>
                      <td>{orderPaymentTypes.find((i) => i.value === Number(item?.payment_type))?.label || "-"}</td>
                      <td className="font-semibold text-slate-800">{item.transaction_id}</td>
                      <td>{item.sales_person_name}</td>
                      <td className="font-semibold text-slate-800">{item.amount ? `₹${item.amount}` : "-"}</td>
                      <td>{item.balance_amount ? `₹${item.balance_amount}` : "-"}</td>
                      <td><span className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${statusMeta(item.status)}`}>{item.status}</span></td>
                      {localStorage.getItem("role") === roles.financer ? (
                        <td>
                          <div className="flex gap-2">
                            {item.status === "ACTIVE" ? (
                              <>
                                <button type="button" className={cfBtn.approve} onClick={() => handleMultiOrderPaymentActionClick(item, "PAID")}>Approve</button>
                                <button type="button" className={cfBtn.reject} onClick={() => handleMultiOrderPaymentActionClick(item, "REJECTED")}>Reject</button>
                              </>
                            ) : null}
                          </div>
                        </td>
                      ) : null}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <NoDataFound colspan={localStorage.getItem("role") === roles.financer ? 7 : 6} />
              )}
            </table>
            {/* Mobile cards */}
            <div className="flex flex-col gap-3 p-3 md:hidden">
              {multiOrderPayments?.length > 0 ? (
                multiOrderPayments.map((item, index) => (
                  <div key={index} className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
                    <div className="flex items-start justify-between gap-2">
                      <div className="min-w-0">
                        <div className="truncate font-semibold text-slate-800">{item.transaction_id}</div>
                        <div className="mt-0.5 text-xs text-slate-400">{item.sales_person_name || "—"}</div>
                      </div>
                      <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${statusMeta(item.status)}`}>{item.status}</span>
                    </div>
                    <div className="mt-2.5 grid grid-cols-2 gap-2 text-sm">
                      <div><div className="text-[11px] uppercase tracking-wide text-slate-400">Payment Type</div><div className="font-medium text-slate-700">{orderPaymentTypes.find((i) => i.value === Number(item?.payment_type))?.label || "-"}</div></div>
                      <div className="text-right"><div className="text-[11px] uppercase tracking-wide text-slate-400">Amount</div><div className="font-semibold text-slate-800">{item.amount ? `₹${item.amount}` : "-"}</div></div>
                      <div><div className="text-[11px] uppercase tracking-wide text-slate-400">Balance</div><div className="font-medium text-slate-700">{item.balance_amount ? `₹${item.balance_amount}` : "-"}</div></div>
                    </div>
                    {localStorage.getItem("role") === roles.financer && item.status === "ACTIVE" ? (
                      <div className="mt-3 flex gap-1.5 border-t border-slate-100 pt-3">
                        <button type="button" className={cfBtn.approve} onClick={() => handleMultiOrderPaymentActionClick(item, "PAID")}>Approve</button>
                        <button type="button" className={cfBtn.reject} onClick={() => handleMultiOrderPaymentActionClick(item, "REJECTED")}>Reject</button>
                      </div>
                    ) : null}
                  </div>
                ))
              ) : (
                <div className="py-10 text-center text-sm text-slate-400">No transactions found</div>
              )}
            </div>
            </>
          )}
        </div>

        {/* Pagination */}
        <div className="flex shrink-0 justify-end border-t border-slate-200 bg-white px-4 py-2.5">
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        </div>
      </div>
      {/* ==== DRAWER FOR ADD PAYMENT LINK FORM ==== */}
      <SlDrawer
      label="Add New Payment"
      open={showForm}
      onSlRequestClose={() => {
        setShowForm(false);
        formik.resetForm();
        chequeFormik.resetForm();
        cashFormik.resetForm();
        IMPS_NEFT_RTGSFormik.resetForm();
      }}
      style={{
        "--size": "50%",
        padding: "24px",
      }}
    >
    <SlTabGroup  ref={tabGroupRef} onSlTabShow={(e) => setActiveTab(e.detail.name)}>
      {localStorage.getItem("role") === roles.ops && <SlTab slot="nav" panel="cashfree" active={activeTab === 'cashfree'}>
        Cashfree Payment Link
      </SlTab>}
      <SlTab slot="nav" panel="cheque">
        Cheque Payment
      </SlTab>
      <SlTab slot="nav" panel="cash">
        Cash Payment
      </SlTab>
      <SlTab slot="nav" panel="IMPS/NEFT/RTGS">
        IMPS/NEFT/RTGS
      </SlTab>

      {/* CASHFREE TAB */}
      <SlTabPanel name="cashfree">
        <form onSubmit={formik.handleSubmit} style={{ padding: "20px 0" }}>
          <div
            className="grid grid-cols-2 gap-3 mt-3"
            style={{ gap: "20px", marginTop: "20px" }}
          >
            {/* Sales Person */}
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Sales Person
              </label>
              <Select
                placeholder="Select sales person"
                value={
                  salesList.find(
                    (option) => option.value === formik.values.sales_person_id
                  ) || null
                }
                onChange={(selectedOption) => {
                  formik.setFieldValue(
                    "sales_person_id",
                    selectedOption?.value || 0
                  );
                }}
                options={salesList}
                onBlur={() => formik.setFieldTouched("sales_person_id", true)}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "6px",
                    borderWidth: "1px",
                    borderColor:
                      formik.errors.sales_person_id &&
                      formik.touched.sales_person_id
                        ? "#dc3545"
                        : "#ced4da",
                    boxShadow: "none",
                    minHeight: "40px",
                  }),
                }}
              />
              {formik.errors.sales_person_id &&
                formik.touched.sales_person_id && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {formik.errors.sales_person_id}
                  </div>
                )}
            </div>

            {/* Amount */}
            <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Amount"
                type="number"
                placeholder="Enter amount"
                value={formik.values.link_amount}
                required
                className={
                  formik.errors.link_amount && formik.touched.link_amount
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  formik.setFieldValue("link_amount", e.target.value);
                }}
                onBlur={formik.handleBlur}
                name="link_amount"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    formik.errors.link_amount && formik.touched.link_amount
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {formik.errors.link_amount && formik.touched.link_amount && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {formik.errors.link_amount}
                </div>
              )}
            </div>

            {/* Customer Name */}
            <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Customer Name"
                placeholder="Enter customer's name"
                value={formik.values.customer_name}
                className={
                  formik.errors.customer_name && formik.touched.customer_name
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  formik.setFieldValue("customer_name", e.target.value);
                }}
                onBlur={formik.handleBlur}
                name="customer_name"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    formik.errors.customer_name && formik.touched.customer_name
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {formik.errors.customer_name && formik.touched.customer_name && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {formik.errors.customer_name}
                </div>
              )}
            </div>

            {/* Customer Email */}
            <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Customer Email"
                type="email"
                placeholder="Enter email"
                value={formik.values.customer_email}
                className={
                  formik.errors.customer_email && formik.touched.customer_email
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  formik.setFieldValue("customer_email", e.target.value);
                }}
                onBlur={formik.handleBlur}
                name="customer_email"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    formik.errors.customer_email &&
                      formik.touched.customer_email
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {formik.errors.customer_email &&
                formik.touched.customer_email && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {formik.errors.customer_email}
                  </div>
                )}
            </div>

            {/* Customer Phone */}
            <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Customer Phone"
                type="tel"
                placeholder="Enter phone number"
                value={formik.values.customer_phone}
                required
                className={
                  formik.errors.customer_phone && formik.touched.customer_phone
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  formik.setFieldValue("customer_phone", e.target.value);
                }}
                onBlur={formik.handleBlur}
                name="customer_phone"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    formik.errors.customer_phone &&
                      formik.touched.customer_phone
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {formik.errors.customer_phone &&
                formik.touched.customer_phone && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {formik.errors.customer_phone}
                  </div>
                )}
            </div>

            {/* Link Purpose */}
            <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Link Purpose"
                placeholder="Enter purpose"
                value={formik.values.link_purpose}
                required
                className={
                  formik.errors.link_purpose && formik.touched.link_purpose
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  formik.setFieldValue("link_purpose", e.target.value);
                }}
                onBlur={formik.handleBlur}
                name="link_purpose"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    formik.errors.link_purpose && formik.touched.link_purpose
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {formik.errors.link_purpose && formik.touched.link_purpose && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {formik.errors.link_purpose}
                </div>
              )}
            </div>
          </div>

          <div
            className="d-flex gap-2 mt-4"
            style={{
              marginTop: "32px",
              gap: "12px",
              justifyContent: "flex-end",
              paddingTop: "20px",
              borderTop: "1px solid #dee2e6",
            }}
          >
            <SlButton
              type="submit"
              variant="primary"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? "Adding..." : "Add Payment Link"}
            </SlButton>
            <SlButton
              type="button"
              variant="default"
              onClick={() => {
                setShowForm(false);
                formik.resetForm();
              }}
            >
              Cancel
            </SlButton>
          </div>
        </form>

        <div className="w-full" style={{ textAlign: "center", margin: "20px 0" }}>
          OR
        </div>

        <div className="d-flex gap-2">
          <SlInput 
            type="text" 
            placeholder="Add Direct Link" 
            value={addDirectLink} 
            onSlInput={(e) => setAddDirectLink(e.target.value)} 
          />
          <SlButton 
            variant="primary" 
            onClick={() => handleAddDirectLink()} 
            disabled={!addDirectLink}
          >
            Add Direct Link
          </SlButton>
        </div>
      </SlTabPanel>

      {/* CHEQUE TAB */}
      <SlTabPanel name="cheque">
        <form onSubmit={chequeFormik.handleSubmit} style={{ padding: "20px 0" }}>
          <div
            className="grid grid-cols-2 gap-3 mt-3"
            style={{ gap: "20px", marginTop: "20px" }}
          >

            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500" }}>Transaction Type</label>
              <div className="d-flex gap-2 flex-wrap">
                <SlButton
                  type="button"
                  size="small"
                  variant={chequeFormik.values.transaction_type === 'regular' ? 'primary' : 'default'}
                  onClick={() => {
                    chequeFormik.setFieldValue("transaction_type", "regular");
                    chequeFormik.setFieldValue("multi_order_payment", false);
                    chequeFormik.setFieldValue("mopd_id", 0);
                    chequeFormik.setFieldValue("sales_person_id", 0);
                    chequeFormik.setFieldValue("order_id", "");
                    chequeFormik.setFieldValue("transaction_id", "");
                    chequeFormik.setFieldValue("amount", 0);
                    setSelectedOrderCheque(null);
                    clearPaymentMetaFields(chequeFormik, setOrderInvoicesCheque);
                  }}
                >
                  Regular
                </SlButton>
                <SlButton
                  type="button"
                  size="small"
                  variant={chequeFormik.values.transaction_type === 'multi_order_payment' ? 'primary' : 'default'}
                  onClick={() => {
                    chequeFormik.setFieldValue("transaction_type", "multi_order_payment");
                    chequeFormik.setFieldValue("multi_order_payment", true);
                    chequeFormik.setFieldValue("mopd_id", 0);
                    chequeFormik.setFieldValue("sales_person_id", 0);
                    chequeFormik.setFieldValue("order_id", "");
                    chequeFormik.setFieldValue("transaction_id", "");
                    chequeFormik.setFieldValue("amount", 0);
                    setSelectedOrderCheque(null);
                    clearPaymentMetaFields(chequeFormik, setOrderInvoicesCheque);
                  }}
                >
                  Multi Order Payment
                </SlButton>
                <SlButton
                  type="button"
                  size="small"
                  variant={chequeFormik.values.transaction_type === 'payment_of_multi_order_payment' ? 'primary' : 'default'}
                  onClick={() => {
                    chequeFormik.setFieldValue("transaction_type", "payment_of_multi_order_payment");
                    chequeFormik.setFieldValue("multi_order_payment", false);
                    chequeFormik.setFieldValue("mopd_id", 0);
                    chequeFormik.setFieldValue("sales_person_id", 0);
                    chequeFormik.setFieldValue("order_id", "");
                    chequeFormik.setFieldValue("transaction_id", "");
                    chequeFormik.setFieldValue("amount", 0);
                    setSelectedOrderCheque(null);
                    clearPaymentMetaFields(chequeFormik, setOrderInvoicesCheque);
                  }}
                >
                  Payment of MOP
                </SlButton>
              </div>
            </div>
            {/*Payment of Multi Order Payment */}
            {
              chequeFormik.values.transaction_type === 'payment_of_multi_order_payment' &&
              <div>
                <label style={{ display: "block", marginBottom: "8px" }}>Payment of Multi Order Payment</label>
                <Select
                  placeholder="Select payment of multi order payment"
                  value={multiOrderPaymentOptions.find(option => option.value === chequeFormik.values.mopd_id) || null}
                  onChange={(selectedOption) => {
                    chequeFormik.setFieldValue("mopd_id", selectedOption?.value || 0);
                    chequeFormik.setFieldValue("sales_person_id", selectedOption?.sales_person_id || 0);
                  }}
                  options={[{label: "Select Payment of Multi Order Payment", value: ""},...multiOrderPaymentOptions]}
                />
                {chequeFormik.errors.mopd_id && chequeFormik.touched.mopd_id && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {chequeFormik.errors.mopd_id}
                  </div>
                )}
              </div>
            }
            {/* Sales Person */}
            {chequeFormik.values.transaction_type !== 'payment_of_multi_order_payment' && <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Sales Person
              </label>
              <Select
                placeholder="Select sales person"
                value={
                  salesList.find(
                    (option) => option.value === chequeFormik.values.sales_person_id
                  ) || null
                }
                onChange={(selectedOption) => {
                  chequeFormik.setFieldValue(
                    "sales_person_id",
                    selectedOption?.value || 0
                  );
                }}
                options={salesList}
                onBlur={() => chequeFormik.setFieldTouched("sales_person_id", true)}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "6px",
                    borderWidth: "1px",
                    borderColor:
                      chequeFormik.errors.sales_person_id &&
                      chequeFormik.touched.sales_person_id
                        ? "#dc3545"
                        : "#ced4da",
                    boxShadow: "none",
                    minHeight: "40px",
                  }),
                }}
              />
              {chequeFormik.errors.sales_person_id &&
                chequeFormik.touched.sales_person_id && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {chequeFormik.errors.sales_person_id}
                  </div>
                )}
            </div>}

            {/* Amount */}
            <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Amount"
                type="number"
                placeholder="Enter amount"
                value={chequeFormik.values.amount}
                required
                className={
                  chequeFormik.errors.amount && chequeFormik.touched.amount
                    ? "error"
                    : ""
                }
                max={chequeFormik.values.mopd_id ? multiOrderPaymentOptions.find(option => option.value === chequeFormik.values.mopd_id)?.balance_amount : undefined}
                onSlInput={(e) => {
                  chequeFormik.setFieldValue("amount", e.target.value);
                }}
                onBlur={chequeFormik.handleBlur}
                name="amount"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    chequeFormik.errors.amount && chequeFormik.touched.amount
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {chequeFormik.values.mopd_id ? <div>
                <p className="text-sm text-gray-500">Maximum Amount: {multiOrderPaymentOptions.find(option => option.value === chequeFormik.values.mopd_id)?.balance_amount}</p>
              </div> : null}
              {chequeFormik.errors.amount && chequeFormik.touched.amount && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {chequeFormik.errors.amount}
                </div>
              )}
            </div>

            {/* Order ID */}
            {chequeFormik.values.transaction_type !== 'multi_order_payment' && <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", marginBottom: "8px" }}>
              Order ID
            </label>
            <Select
              placeholder="Search order by ID or name..."
              value={selectedOrderCheque}
              onChange={(selectedOption) => {
                handleOrderSelect(
                  selectedOption,
                  setSelectedOrderCheque,
                  chequeFormik,
                  setOrderInvoicesCheque
                );
              }}
              options={ordersList}
              onInputChange={debounce((inputValue) => {
                handleOrderSearch(inputValue, chequeFormik.values.sales_person_id);
              }, 500)}
              isDisabled={!chequeFormik.values.sales_person_id}
              onBlur={() => chequeFormik.setFieldTouched("order_id", true)}
              isSearchable
              isLoading={isLoadingOrders}
              noOptionsMessage={() => 
                orderSearchTerm.length < 2 
                  ? "Type at least 2 characters to search" 
                  : "No orders found"
              }
              styles={{
                control: (provided) => ({
                  ...provided,
                  borderRadius: "6px",
                  borderWidth: "1px",
                  borderColor:
                    chequeFormik.errors.order_id &&
                    chequeFormik.touched.order_id
                      ? "#dc3545"
                      : "#ced4da",
                  boxShadow: "none",
                  minHeight: "40px",
                }),
              }}
            />
            {chequeFormik.errors.order_id &&
              chequeFormik.touched.order_id && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {chequeFormik.errors.order_id}
                </div>
              )}
          </div>}

            {chequeFormik.values.transaction_type !== 'multi_order_payment' &&
              renderPaymentMetaFields(chequeFormik, orderInvoicesCheque)}

            {/* Transaction ID */}
            {chequeFormik.values.transaction_type !== 'payment_of_multi_order_payment' && <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Transaction ID"
                placeholder="Enter transaction ID"
                value={chequeFormik.values.transaction_id}
                required
                className={
                  chequeFormik.errors.transaction_id && chequeFormik.touched.transaction_id
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  chequeFormik.setFieldValue("transaction_id", e.target.value);
                }}
                onBlur={chequeFormik.handleBlur}
                name="transaction_id"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    chequeFormik.errors.transaction_id && chequeFormik.touched.transaction_id
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {chequeFormik.errors.transaction_id && chequeFormik.touched.transaction_id && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {chequeFormik.errors.transaction_id}
                </div>
              )}
            </div>}
          </div>

          <div
            className="d-flex gap-2 mt-4 items-center"
            style={{
              marginTop: "32px",
              gap: "12px",
              justifyContent: "flex-end",
              paddingTop: "20px",
              borderTop: "1px solid #dee2e6",
            }}
          >
            <SlButton
              type="submit"
              variant="primary"
              disabled={chequeFormik.isSubmitting}
            >
              {chequeFormik.isSubmitting ? "Adding..." : "Add Cheque Payment"}
            </SlButton>
            <SlButton
              type="button"
              variant="default"
              onClick={() => {
                setShowForm(false);
                chequeFormik.resetForm();
              }}
            >
              Cancel
            </SlButton>
          </div>
        </form>
      </SlTabPanel>

      {/* CASH TAB */}
      <SlTabPanel name="cash">
        <form onSubmit={cashFormik.handleSubmit} style={{ padding: "20px 0" }}>
          <div
            className="grid grid-cols-2 gap-3 mt-3"
            style={{ gap: "20px", marginTop: "20px" }}
          >
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500" }}>Transaction Type</label>
              <div className="d-flex gap-2 flex-wrap">
                <SlButton
                  type="button"
                  size="small"
                  variant={cashFormik.values.transaction_type === 'regular' ? 'primary' : 'default'}
                  onClick={() => {
                    cashFormik.setFieldValue("transaction_type", "regular");
                    cashFormik.setFieldValue("multi_order_payment", false);
                    cashFormik.setFieldValue("mopd_id", 0);
                    cashFormik.setFieldValue("sales_person_id", 0);
                    cashFormik.setFieldValue("pan_no", "");
                    cashFormik.setFieldValue("order_id", "");
                    cashFormik.setFieldValue("transaction_id", "");
                    cashFormik.setFieldValue("amount", 0);
                    setSelectedOrderCash(null);
                    clearPaymentMetaFields(cashFormik, setOrderInvoicesCash);
                  }}
                >
                  Regular
                </SlButton>
                <SlButton
                  type="button"
                  size="small"
                  variant={cashFormik.values.transaction_type === 'multi_order_payment' ? 'primary' : 'default'}
                  onClick={() => {
                    cashFormik.setFieldValue("transaction_type", "multi_order_payment");
                    cashFormik.setFieldValue("multi_order_payment", true);
                    cashFormik.setFieldValue("mopd_id", 0);
                    cashFormik.setFieldValue("sales_person_id", 0);
                    cashFormik.setFieldValue("pan_no", "");
                    cashFormik.setFieldValue("order_id", "");
                    cashFormik.setFieldValue("transaction_id", "");
                    cashFormik.setFieldValue("amount", 0);
                    setSelectedOrderCash(null);
                    clearPaymentMetaFields(cashFormik, setOrderInvoicesCash);
                  }}
                >
                  Multi Order Payment
                </SlButton>
                <SlButton
                  type="button"
                  size="small"
                  variant={cashFormik.values.transaction_type === 'payment_of_multi_order_payment' ? 'primary' : 'default'}
                  onClick={() => {
                    cashFormik.setFieldValue("transaction_type", "payment_of_multi_order_payment");
                    cashFormik.setFieldValue("multi_order_payment", false);
                    cashFormik.setFieldValue("mopd_id", 0);
                    cashFormik.setFieldValue("sales_person_id", 0);
                    cashFormik.setFieldValue("pan_no", "");
                    cashFormik.setFieldValue("order_id", "");
                    cashFormik.setFieldValue("transaction_id", "");
                    cashFormik.setFieldValue("amount", 0);
                    setSelectedOrderCash(null);
                    clearPaymentMetaFields(cashFormik, setOrderInvoicesCash);
                  }}
                >
                  Payment of MOP
                </SlButton>
              </div>
            </div>
            {/*Payment of Multi Order Payment */}
            {
              cashFormik.values.transaction_type === 'payment_of_multi_order_payment' &&
              <div>
                <label style={{ display: "block", marginBottom: "8px" }}>Payment of Multi Order Payment</label>
                <Select
                  placeholder="Select payment of multi order payment"
                  value={multiOrderPaymentOptions.find(option => option.value === cashFormik.values.mopd_id) || null}
                  onChange={(selectedOption) => {
                    cashFormik.setFieldValue("mopd_id", selectedOption?.value || 0);
                    cashFormik.setFieldValue("sales_person_id", selectedOption?.sales_person_id || 0);
                    cashFormik.setFieldValue("pan_no", selectedOption?.pan_no || "");
                  }}
                  options={[{label: "Select Payment of Multi Order Payment", value: ""},...multiOrderPaymentOptions]}
                />
                {cashFormik.errors.mopd_id && cashFormik.touched.mopd_id && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {cashFormik.errors.mopd_id}
                  </div>
                )}
              </div>
            }
            {/* Sales Person */}
            {cashFormik.values.transaction_type !== 'payment_of_multi_order_payment' && <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Sales Person
              </label>
              <Select
                placeholder="Select sales person"
                value={
                  salesList.find(
                    (option) => option.value === cashFormik.values.sales_person_id
                  ) || null
                }
                onChange={(selectedOption) => {
                  cashFormik.setFieldValue(
                    "sales_person_id",
                    selectedOption?.value || 0
                  );
                }}
                options={salesList}
                onBlur={() => cashFormik.setFieldTouched("sales_person_id", true)}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "6px",
                    borderWidth: "1px",
                    borderColor:
                      cashFormik.errors.sales_person_id &&
                      cashFormik.touched.sales_person_id
                        ? "#dc3545"
                        : "#ced4da",
                    boxShadow: "none",
                    minHeight: "40px",
                  }),
                }}
              />
              {cashFormik.errors.sales_person_id &&
                cashFormik.touched.sales_person_id && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {cashFormik.errors.sales_person_id}
                  </div>
                )}
            </div>}

            {/* Amount */}
            <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Amount"
                type="number"
                placeholder="Enter amount"
                value={cashFormik.values.amount}
                required
                className={
                  cashFormik.errors.amount && cashFormik.touched.amount
                    ? "error"
                    : ""
                }
                max={cashFormik.values.mopd_id ? multiOrderPaymentOptions.find(option => option.value === cashFormik.values.mopd_id)?.balance_amount : undefined}
                onSlInput={(e) => {
                  cashFormik.setFieldValue("amount", e.target.value);
                }}
                onBlur={cashFormik.handleBlur}
                name="amount"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    cashFormik.errors.amount && cashFormik.touched.amount
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {cashFormik.errors.amount && cashFormik.touched.amount && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {cashFormik.errors.amount}
                </div>
              )}
              {cashFormik.values.mopd_id ? <div>
                <p className="text-sm text-gray-500">Maximum Amount: {multiOrderPaymentOptions.find(option => option.value === cashFormik.values.mopd_id)?.balance_amount}</p>
              </div> : null}
            </div>

            {/* Order ID */}
            {cashFormik.values.transaction_type !== 'multi_order_payment' && <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Order ID
              </label>
              <Select
                placeholder="Search order by ID or name..."
                value={selectedOrderCash}
                onChange={(selectedOption) => {
                  handleOrderSelect(
                    selectedOption,
                    setSelectedOrderCash,
                    cashFormik,
                    setOrderInvoicesCash
                  );
                }}
                options={ordersList}
                onInputChange={debounce((inputValue) => {
                  handleOrderSearch(inputValue, cashFormik.values.sales_person_id);
                }, 500)}
                isDisabled={!cashFormik.values.sales_person_id} 
                onBlur={() => cashFormik.setFieldTouched("order_id", true)}
                isSearchable
                isLoading={isLoadingOrders}
                noOptionsMessage={() => 
                  orderSearchTerm.length < 2 
                    ? "Type at least 2 characters to search" 
                    : "No orders found"
                }
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "6px",
                    borderWidth: "1px",
                    borderColor:
                      cashFormik.errors.order_id &&
                      cashFormik.touched.order_id
                        ? "#dc3545"
                        : "#ced4da",
                    boxShadow: "none",
                    minHeight: "40px",
                  }),
                }}
              />
              {cashFormik.errors.order_id &&
                cashFormik.touched.order_id && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {cashFormik.errors.order_id}
                  </div>
                )}
            </div>}

            {cashFormik.values.transaction_type !== 'multi_order_payment' &&
              renderPaymentMetaFields(cashFormik, orderInvoicesCash)}

            {/* Transaction ID */}
            {cashFormik.values.transaction_type !== 'payment_of_multi_order_payment' && <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Transaction ID"
                placeholder="Enter transaction ID"
                value={cashFormik.values.transaction_id}
                required
                className={
                  cashFormik.errors.transaction_id && cashFormik.touched.transaction_id
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  cashFormik.setFieldValue("transaction_id", e.target.value);
                }}
                onBlur={cashFormik.handleBlur}
                name="transaction_id"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    cashFormik.errors.transaction_id && cashFormik.touched.transaction_id
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {cashFormik.errors.transaction_id && cashFormik.touched.transaction_id && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {cashFormik.errors.transaction_id}
                </div>
              )}
            </div>}
            {cashFormik.values.transaction_type !== 'payment_of_multi_order_payment' && <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="PAN no"
                type="string"
                placeholder="Enter PAN no"
                value={cashFormik.values.pan_no}
                required
                className={
                  cashFormik.errors.pan_no && cashFormik.touched.pan_no
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  cashFormik.setFieldValue("pan_no", e.target.value);
                }}
                onBlur={cashFormik.handleBlur}
                name="pan_no"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                    cashFormik.errors.pan_no && cashFormik.touched.pan_no
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {cashFormik.errors.pan_no && cashFormik.touched.pan_no && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {cashFormik.errors.pan_no}
                </div>
              )}
            </div>}
          </div>

          <div
            className="d-flex gap-2 mt-4"
            style={{
              marginTop: "32px",
              gap: "12px",
              justifyContent: "flex-end",
              paddingTop: "20px",
              borderTop: "1px solid #dee2e6",
            }}
          >
            <SlButton
              type="submit"
              variant="primary"
              disabled={cashFormik.isSubmitting}
            >
              {cashFormik.isSubmitting ? "Adding..." : "Add Cash Payment"}
            </SlButton>
            <SlButton
              type="button"
              variant="default"
              onClick={() => {
                setShowForm(false);
                cashFormik.resetForm();
              }}
            >
              Cancel
            </SlButton>
          </div>
        </form>
      </SlTabPanel>

      <SlTabPanel name="IMPS/NEFT/RTGS">
        <form onSubmit={IMPS_NEFT_RTGSFormik.handleSubmit} style={{ padding: "20px 0" }}>
          <div
            className="grid grid-cols-2 gap-3 mt-3"
            style={{ gap: "20px", marginTop: "20px" }}
          >
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500" }}>Transaction Type</label>
              <div className="d-flex gap-2 flex-wrap">
                <SlButton
                  type="button"
                  size="small"
                  variant={IMPS_NEFT_RTGSFormik.values.transaction_type === 'regular' ? 'primary' : 'default'}
                  onClick={() => {
                    IMPS_NEFT_RTGSFormik.setFieldValue("transaction_type", "regular");
                    IMPS_NEFT_RTGSFormik.setFieldValue("multi_order_payment", false);
                    IMPS_NEFT_RTGSFormik.setFieldValue("mopd_id", 0);
                    IMPS_NEFT_RTGSFormik.setFieldValue("sales_person_id", 0);
                    IMPS_NEFT_RTGSFormik.setFieldValue("order_id", "");
                    IMPS_NEFT_RTGSFormik.setFieldValue("transaction_id", "");
                    IMPS_NEFT_RTGSFormik.setFieldValue("amount", 0);
                    setSelectedOrderIMPS(null);
                    clearPaymentMetaFields(IMPS_NEFT_RTGSFormik, setOrderInvoicesIMPS);
                  }}
                >
                  Regular
                </SlButton>
                <SlButton
                  type="button"
                  size="small"
                  variant={IMPS_NEFT_RTGSFormik.values.transaction_type === 'multi_order_payment' ? 'primary' : 'default'}
                  onClick={() => {
                    IMPS_NEFT_RTGSFormik.setFieldValue("transaction_type", "multi_order_payment");
                    IMPS_NEFT_RTGSFormik.setFieldValue("multi_order_payment", true);
                    IMPS_NEFT_RTGSFormik.setFieldValue("mopd_id", 0);
                    IMPS_NEFT_RTGSFormik.setFieldValue("sales_person_id", 0);
                    IMPS_NEFT_RTGSFormik.setFieldValue("order_id", "");
                    IMPS_NEFT_RTGSFormik.setFieldValue("transaction_id", "");
                    IMPS_NEFT_RTGSFormik.setFieldValue("amount", 0);
                    setSelectedOrderIMPS(null);
                    clearPaymentMetaFields(IMPS_NEFT_RTGSFormik, setOrderInvoicesIMPS);
                  }}
                >
                  Multi Order Payment
                </SlButton>
                <SlButton
                  type="button"
                  size="small"
                  variant={IMPS_NEFT_RTGSFormik.values.transaction_type === 'payment_of_multi_order_payment' ? 'primary' : 'default'}
                  onClick={() => {
                    IMPS_NEFT_RTGSFormik.setFieldValue("transaction_type", "payment_of_multi_order_payment");
                    IMPS_NEFT_RTGSFormik.setFieldValue("multi_order_payment", false);
                    IMPS_NEFT_RTGSFormik.setFieldValue("mopd_id", 0);
                    IMPS_NEFT_RTGSFormik.setFieldValue("sales_person_id", 0);
                    IMPS_NEFT_RTGSFormik.setFieldValue("order_id", "");
                    IMPS_NEFT_RTGSFormik.setFieldValue("transaction_id", "");
                    IMPS_NEFT_RTGSFormik.setFieldValue("amount", 0);
                    setSelectedOrderIMPS(null);
                    clearPaymentMetaFields(IMPS_NEFT_RTGSFormik, setOrderInvoicesIMPS);
                  }}
                >
                  Payment of MOP
                </SlButton>
              </div>
            </div>

            {/* Payment of Multi Order Payment */}
            {
              IMPS_NEFT_RTGSFormik.values.transaction_type === 'payment_of_multi_order_payment' &&
              <div>
                <label style={{ display: "block", marginBottom: "8px" }}>Payment of Multi Order Payment</label>
                <Select
                  placeholder="Select payment of multi order payment"
                  value={multiOrderPaymentOptions.find(option => option.value === IMPS_NEFT_RTGSFormik.values.mopd_id) || null}
                  onChange={(selectedOption) => {
                    IMPS_NEFT_RTGSFormik.setFieldValue("mopd_id", selectedOption?.value || 0);
                    IMPS_NEFT_RTGSFormik.setFieldValue("sales_person_id", selectedOption?.sales_person_id || 0);
                  }}
                  options={[{label: "Select Payment of Multi Order Payment", value: ""},...multiOrderPaymentOptions]}
                />
                {IMPS_NEFT_RTGSFormik.errors.mopd_id && IMPS_NEFT_RTGSFormik.touched.mopd_id && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {IMPS_NEFT_RTGSFormik.errors.mopd_id}
                  </div>
                )}
              </div>
            }
            {/* Sales Person */}
            {IMPS_NEFT_RTGSFormik.values.transaction_type !== 'payment_of_multi_order_payment' && <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px" }}>
                Sales Person
              </label>
              <Select
                placeholder="Select sales person"
                value={
                  salesList.find(
                    (option) => option.value === IMPS_NEFT_RTGSFormik.values.sales_person_id
                  ) || null
                }
                onChange={(selectedOption) => {
                  IMPS_NEFT_RTGSFormik.setFieldValue(
                    "sales_person_id",
                    selectedOption?.value || 0
                  );
                }}
                options={salesList}
                onBlur={() => IMPS_NEFT_RTGSFormik.setFieldTouched("sales_person_id", true)}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "6px",
                    borderWidth: "1px",
                    borderColor:
                    IMPS_NEFT_RTGSFormik.errors.sales_person_id &&
                    IMPS_NEFT_RTGSFormik.touched.sales_person_id
                        ? "#dc3545"
                        : "#ced4da",
                    boxShadow: "none",
                    minHeight: "40px",
                  }),
                }}
              />
              {IMPS_NEFT_RTGSFormik.errors.sales_person_id &&
                IMPS_NEFT_RTGSFormik.touched.sales_person_id && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                      fontWeight: "500",
                    }}
                  >
                    {IMPS_NEFT_RTGSFormik.errors.sales_person_id}
                  </div>
                )}
            </div>}

            {/* Amount */}
            <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Amount"
                type="number"
                placeholder="Enter amount"
                value={IMPS_NEFT_RTGSFormik.values.amount}
                required
                className={
                  IMPS_NEFT_RTGSFormik.errors.amount && IMPS_NEFT_RTGSFormik.touched.amount
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  IMPS_NEFT_RTGSFormik.setFieldValue("amount", e.target.value);
                }}
                max={IMPS_NEFT_RTGSFormik.values.mopd_id ? multiOrderPaymentOptions.find(option => option.value === IMPS_NEFT_RTGSFormik.values.mopd_id)?.balance_amount : undefined}
                onBlur={IMPS_NEFT_RTGSFormik.handleBlur}
                name="amount"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                  IMPS_NEFT_RTGSFormik.errors.amount && IMPS_NEFT_RTGSFormik.touched.amount
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {IMPS_NEFT_RTGSFormik.errors.amount && IMPS_NEFT_RTGSFormik.touched.amount && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {IMPS_NEFT_RTGSFormik.errors.amount}
                </div>
              )}
            {IMPS_NEFT_RTGSFormik.values.mopd_id ? <div>
              <p className="text-sm text-gray-500">Maximum Amount: {multiOrderPaymentOptions.find(option => option.value === IMPS_NEFT_RTGSFormik.values.mopd_id)?.balance_amount}</p>
            </div> : null}
            </div>

            {/* Order ID */}
            {IMPS_NEFT_RTGSFormik.values.transaction_type !== 'multi_order_payment' && <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", marginBottom: "8px" }}>
              Order ID
            </label>
            <Select
              placeholder="Search order by ID or name..."
              value={selectedOrderIMPS}
              onChange={(selectedOption) => {
                handleOrderSelect(
                  selectedOption,
                  setSelectedOrderIMPS,
                  IMPS_NEFT_RTGSFormik,
                  setOrderInvoicesIMPS
                );
              }}
              options={ordersList}
              onInputChange={debounce((inputValue) => {
                handleOrderSearch(inputValue, IMPS_NEFT_RTGSFormik.values.sales_person_id);
              }, 500)}
              isDisabled={!IMPS_NEFT_RTGSFormik.values.sales_person_id}
              onBlur={() => IMPS_NEFT_RTGSFormik.setFieldTouched("order_id", true)}
              isSearchable
              isLoading={isLoadingOrders}
              noOptionsMessage={() => 
                orderSearchTerm.length < 2 
                  ? "Type at least 2 characters to search" 
                  : "No orders found"
              }
              styles={{
                control: (provided) => ({
                  ...provided,
                  borderRadius: "6px",
                  borderWidth: "1px",
                  borderColor:
                  IMPS_NEFT_RTGSFormik.errors.order_id &&
                  IMPS_NEFT_RTGSFormik.touched.order_id
                      ? "#dc3545"
                      : "#ced4da",
                  boxShadow: "none",
                  minHeight: "40px",
                }),
              }}
            />
            {IMPS_NEFT_RTGSFormik.errors.order_id &&
              IMPS_NEFT_RTGSFormik.touched.order_id && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {IMPS_NEFT_RTGSFormik.errors.order_id}
                </div>
              )}
            </div>}

            {IMPS_NEFT_RTGSFormik.values.transaction_type !== 'multi_order_payment' &&
              renderPaymentMetaFields(IMPS_NEFT_RTGSFormik, orderInvoicesIMPS)}

            {/* Transaction ID */}
            {IMPS_NEFT_RTGSFormik.values.transaction_type !== 'payment_of_multi_order_payment' && <div style={{ marginBottom: "16px" }}>
              <SlInput
                label="Transaction ID"
                placeholder="Enter transaction ID"
                value={IMPS_NEFT_RTGSFormik.values.transaction_id}
                required
                className={
                  IMPS_NEFT_RTGSFormik.errors.transaction_id && IMPS_NEFT_RTGSFormik.touched.transaction_id
                    ? "error"
                    : ""
                }
                onSlInput={(e) => {
                  IMPS_NEFT_RTGSFormik.setFieldValue("transaction_id", e.target.value);
                }}
                onBlur={IMPS_NEFT_RTGSFormik.handleBlur}
                name="transaction_id"
                style={{
                  "--sl-input-border-radius": "6px",
                  "--sl-input-border-width": "1px",
                  "--sl-input-border-color":
                  IMPS_NEFT_RTGSFormik.errors.transaction_id && IMPS_NEFT_RTGSFormik.touched.transaction_id
                      ? "#dc3545"
                      : "#ced4da",
                }}
              />
              {IMPS_NEFT_RTGSFormik.errors.transaction_id && IMPS_NEFT_RTGSFormik.touched.transaction_id && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {IMPS_NEFT_RTGSFormik.errors.transaction_id}
                </div>
              )}
            </div>}
          </div>

          <div
            className="d-flex gap-2 mt-4"
            style={{
              marginTop: "32px",
              gap: "12px",
              justifyContent: "flex-end",
              paddingTop: "20px",
              borderTop: "1px solid #dee2e6",
            }}
          >
            <SlButton
              type="submit"
              variant="primary"
              disabled={IMPS_NEFT_RTGSFormik.isSubmitting}
            >
              {IMPS_NEFT_RTGSFormik.isSubmitting ? "Adding..." : "Add IMPS_NEFT_RTGS Payment"}
            </SlButton>
            <SlButton
              type="button"
              variant="default"
              onClick={() => {
                setShowForm(false);
                IMPS_NEFT_RTGSFormik.resetForm();
              }}
            >
              Cancel
            </SlButton>
          </div>
        </form>
      </SlTabPanel>
    </SlTabGroup>
      </SlDrawer>
      <Modal
          show={actionModal.isOpen}
          onHide={handleCloseModal}
          size="xl" // Changed to xl for more width
          centered
        >
        <Modal.Header closeButton>
          <Modal.Title>
            {actionModal.isEdit ? "Edit Payment - " : ""}
            {actionModal.action === "APPROVED" ? "APPROVED" : "REJECTED"} Payment Transaction
          </Modal.Title>
        </Modal.Header>
      
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div style={{ display: "flex", gap: "20px", flexDirection: window.innerWidth < 768 ? "column" : "row" }}>
            {/* Left Side - Details */}
            <div style={{ flex: 1 }}>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <td style={{ fontWeight: "600", width: "40%" }}>Order ID:</td>
                      <td>{actionModal.data?.order_id || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "600" }}>Link ID / Transaction ID:</td>
                      <td>{actionModal.data?.link_id || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "600" }}>Cashfree Link ID:</td>
                      <td>{actionModal.data?.cf_link_id || "-"}</td>
                    </tr>
                    {isTdsTransaction(actionModal.data) && (
                      <tr>
                        <td style={{ fontWeight: "600" }}>TDS Of Transaction:</td>
                        <td>
                          {actionModal.data?.tds_ref_link_id || "-"}
                          {actionModal.data?.tds_ref_amount ? ` (₹${actionModal.data.tds_ref_amount})` : ""}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td style={{ fontWeight: "600" }}>Status:</td>
                      <td>
                        <span
                          style={{
                            padding: "4px 12px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: "500",
                            backgroundColor: "#d4edda",
                            color: "#155724",
                          }}
                        >
                          {actionModal.data?.link_status || "-"}
                        </span>
                      </td>
                    </tr>
                    {hasExistingTds(actionModal.data) && (
                      <tr>
                        <td style={{ fontWeight: "600" }}>TDS:</td>
                        <td style={{ fontWeight: "600", color: "#28a745" }}>
                          ₹{String(actionModal.data?.tds).trim()}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td style={{ fontWeight: "600" }}>Amount:</td>
                      <td style={{ fontSize: "16px", fontWeight: "600", color: "#28a745" }}>
                        ₹{actionModal.data?.link_amount || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "600" }}>Purpose:</td>
                      <td>{actionModal.data?.link_purpose || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "600" }}>Customer Name:</td>
                      <td>{actionModal.data?.customer_name || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "600" }}>Customer Email:</td>
                      <td>{actionModal.data?.customer_email || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "600" }}>Customer Phone:</td>
                      <td>{actionModal.data?.customer_phone || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "600" }}>Created By:</td>
                      <td>{actionModal.data?.created_by_name || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "600" }}>Created User Role:</td>
                      <td>{getFirstKeyByValue(roles, actionModal.data?.created_user_role)?.toUpperCase() || "-"}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "600" }}>Created On:</td>
                      <td>{formatDateWithTimeYear(actionModal.data?.created_on) || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              {actionModal.action === "APPROVED" && !hasExistingTds(actionModal.data) && !isTdsTransaction(actionModal.data) && (
                <div className="mt-3">
                  <label style={{ fontWeight: "600", marginBottom: "8px", display: "block" }}>
                    TDS Amount <span style={{ color: "#6c757d", fontWeight: "400" }}>(optional)</span>
                  </label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={tdsAmount}
                    onChange={(e) => setTdsAmount(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                    placeholder="Enter TDS amount"
                    className="form-control"
                  />
                </div>
              )}

              {actionModal.action === "REJECTED" && (
                <div className="mt-3">
                  <label style={{ fontWeight: "600", marginBottom: "8px", display: "block" }}>
                    Rejection Reason <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e.target.value)}
                    placeholder="Enter reason for rejection..."
                    className="form-control"
                    rows="4"
                    style={{ resize: "vertical" }}
                  />
                </div>
              )}
            </div>
            
            {/* Right Side - Payment Proof Preview */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <h6 style={{ fontWeight: "600", marginBottom: "12px" }}>Payment Proof</h6>
              {(() => {
                const proofImages = [
                  ...(actionModal.data?.link_url ? [actionModal.data.link_url] : []),
                  ...(Array.isArray(actionModal.data?.attachment)
                    ? actionModal.data.attachment.filter((url) => typeof url === "string" && url)
                    : []),
                ].filter((url, i, arr) => arr.indexOf(url) === i);

                if (!proofImages.length) {
                  return (
                    <div
                      style={{
                        border: "1px dashed #ddd",
                        borderRadius: "8px",
                        padding: "40px",
                        textAlign: "center",
                        color: "#6c757d",
                        height: "320px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      No image available
                    </div>
                  );
                }

                const index = proofIndex % proofImages.length;
                const proofUrl = proofImages[index];
                // TDS certificates are often PDFs, which the lightbox cannot render
                const isPdfProof = /\.pdf(\?|#|$)/i.test(proofUrl);

                return (
                  <div
                    style={{
                      position: "relative",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      overflow: "hidden",
                      height: "320px",
                      backgroundColor: "#f8f9fa",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {isPdfProof ? (
                      <a
                        href={proofUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "8px", color: "#4952FA", fontWeight: 600 }}
                      >
                        <SlIcon library="lucide" name="file-text" style={{ fontSize: "32px" }}></SlIcon>
                        Open proof (PDF)
                      </a>
                    ) : (
                      <div
                        onClick={() => setAttachmentLightbox(proofUrl)}
                        style={{ height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", cursor: "zoom-in" }}
                      >
                        <img
                          src={proofUrl}
                          alt={`Payment Proof ${index + 1}`}
                          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "path/to/placeholder-image.png"; // Add placeholder image path
                          }}
                        />
                      </div>
                    )}
                    {proofImages.length > 1 && (
                      <>
                        <button
                          type="button"
                          onClick={(e) => { e.stopPropagation(); setProofIndex((i) => (i - 1 + proofImages.length) % proofImages.length); }}
                          style={{ position: "absolute", left: "8px", top: "50%", transform: "translateY(-50%)", background: "rgba(255,255,255,0.85)", border: "1px solid #ddd", borderRadius: "50%", width: "32px", height: "32px", cursor: "pointer" }}
                        >
                          ‹
                        </button>
                        <button
                          type="button"
                          onClick={(e) => { e.stopPropagation(); setProofIndex((i) => (i + 1) % proofImages.length); }}
                          style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", background: "rgba(255,255,255,0.85)", border: "1px solid #ddd", borderRadius: "50%", width: "32px", height: "32px", cursor: "pointer" }}
                        >
                          ›
                        </button>
                        <div style={{ position: "absolute", bottom: "8px", left: "50%", transform: "translateX(-50%)", background: "rgba(0,0,0,0.55)", color: "#fff", fontSize: "12px", padding: "2px 8px", borderRadius: "10px" }}>
                          {index + 1} / {proofImages.length}
                        </div>
                      </>
                    )}
                  </div>
                );
              })()}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <SlButton variant="default" onClick={handleCloseModal}>
            Cancel
          </SlButton>
          
          {actionModal.action === "APPROVED" ? (
            <SlButton variant="success" onClick={handleSubmitAction}>
              Confirm Approve
            </SlButton>
          ) : (
            <SlButton variant="danger" onClick={handleSubmitAction}>
              Confirm Reject
            </SlButton>
          )}
        </Modal.Footer>
      </Modal>

      {attachmentLightbox && (
        <div
          onClick={() => setAttachmentLightbox(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.85)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "zoom-out",
          }}
        >
          <button
            onClick={() => setAttachmentLightbox(null)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "none",
              border: "none",
              color: "#fff",
              fontSize: "32px",
              lineHeight: 1,
              cursor: "pointer",
            }}
          >
            ×
          </button>
          <img
            src={attachmentLightbox}
            alt="Payment proof full view"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "90vw", maxHeight: "90vh", objectFit: "contain", cursor: "default" }}
          />
        </div>
      )}

      {/* Mark the TDS withheld on a transaction as received from the government */}
      <Modal show={tdsReceiveModal.isOpen} onHide={closeTdsReceivedModal} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "18px" }}>Mark TDS as Received</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td style={{ fontWeight: "600", width: "45%" }}>Order ID:</td>
                  <td>{tdsReceiveModal.data?.order_id || "-"}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "600" }}>Link ID / Transaction ID:</td>
                  <td>{tdsReceiveModal.data?.link_id || "-"}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "600" }}>Transaction Amount:</td>
                  <td>{tdsReceiveModal.data?.link_amount ? `₹${tdsReceiveModal.data.link_amount}` : "-"}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "600" }}>TDS Amount:</td>
                  <td style={{ fontWeight: "600", color: "#28a745" }}>
                    ₹{String(tdsReceiveModal.data?.tds ?? "").trim() || "-"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-3">
            <label style={{ fontWeight: "600", marginBottom: "8px", display: "block" }}>
              TDS Proof <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="file"
              className="form-control"
              accept={TDS_PROOF_TYPES.join(",")}
              onChange={handleTdsProofChange}
              disabled={tdsReceiveLoading}
            />
            <div style={{ fontSize: "12px", color: "#6c757d", marginTop: "6px" }}>
              Image or PDF of the TDS certificate / credit proof.
            </div>
          </div>

          <div style={{ fontSize: "13px", color: "#6c757d", marginTop: "16px" }}>
            The TDS amount will be booked as a new TDS transaction in ACTIVE status, and goes
            through the regular approve / reject flow.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <SlButton variant="default" onClick={closeTdsReceivedModal} disabled={tdsReceiveLoading}>
            Cancel
          </SlButton>
          <SlButton variant="success" onClick={submitTdsReceived} loading={tdsReceiveLoading} disabled={tdsReceiveLoading || !tdsProofFile}>
            Mark as Received
          </SlButton>
        </Modal.Footer>
      </Modal>

      {/* TDS confirmation step, shown after "Confirm Approve" */}
      <Modal show={tdsConfirmOpen} onHide={() => setTdsConfirmOpen(false)} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "18px" }}>Confirm TDS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {String(tdsAmount).trim() === "" ? (
            <p style={{ marginBottom: 0 }}>
              You have not entered a TDS amount for this transaction. Do you want to add TDS
              before approving?
            </p>
          ) : (
            <p style={{ marginBottom: 0 }}>
              A TDS amount of <strong>₹{String(tdsAmount).trim()}</strong> will be recorded
              against this transaction. Do you want to continue?
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <SlButton variant="default" onClick={() => setTdsConfirmOpen(false)}>
            {String(tdsAmount).trim() === "" ? "Add TDS" : "Go Back"}
          </SlButton>
          <SlButton variant="success" onClick={submitAction}>
            {String(tdsAmount).trim() === "" ? "Approve without TDS" : "Confirm Approve"}
          </SlButton>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default CashfreePaymentLinkCreation;
